/**
 * This file is auto-generated by graphql-codegen. Do not edit manually!
 * Please execute `npm run graphql-codegen` for updating the type definitions.
 */

/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  Date: any;
  DateTime: any;
  JSON: any;
  JWT: any;
  TimeZone: any;
  URL: any;
  UUID: any;
}

export interface AcceptSoftwareSubscriptionMasterAgreementAmendmentInput {
  eContractId: Scalars['ID'];
}

export interface AcceptSoftwareSubscriptionMasterAgreementAmendmentPayload {
  __typename?: 'AcceptSoftwareSubscriptionMasterAgreementAmendmentPayload';
  subscriptionId: Scalars['ID'];
}

export interface Account extends Node, Pageable {
  __typename?: 'Account';
  address?: Maybe<Address>;
  id: Scalars['ID'];
  isCashOnly?: Maybe<Scalars['Boolean']>;
  isFleetOrderingBlocked?: Maybe<Scalars['Boolean']>;
  isPurchaseOrderNumberMandatory?: Maybe<Scalars['Boolean']>;
  /** @deprecated Not provided in CCMSv2 */
  language?: Maybe<Scalars['String']>;
  originId: Scalars['String'];
  taxExempt?: Maybe<Scalars['String']>;
  /** This is technical field, not shown in UI - it was added for the account compound key in order to resolve reference */
  type?: Maybe<AccountType>;
}

export interface AccountConnection extends Connection {
  __typename?: 'AccountConnection';
  edges: Array<AccountEdge>;
  pageInfo: PageInfo;
}

export interface AccountEdge extends Edge {
  __typename?: 'AccountEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Account;
}

export interface AccountEVoucherAdministrationConfiguration {
  __typename?: 'AccountEVoucherAdministrationConfiguration';
  maxEVoucherQuotationThresholdValue?: Maybe<Scalars['BigDecimal']>;
  maxEVoucherValue?: Maybe<Money>;
  maxNumberOfValidMonths?: Maybe<Scalars['Int']>;
  minQuotationValue?: Maybe<Money>;
}

export interface AccountEVoucherDetails {
  __typename?: 'AccountEVoucherDetails';
  customer?: Maybe<Customer>;
  fleetQuotationInformation?: Maybe<AccountEVoucherFleetQuotationInformation>;
  isPartiallyRedeemable?: Maybe<Scalars['Boolean']>;
  isReactivatable?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use AccountEVoucherDetails.redemptionsInformation */
  redemptionInformation?: Maybe<EVoucherRedemptionInformation>;
  redemptionsInformation?: Maybe<Array<EVoucherRedemptionInformation>>;
  standardQuotationInformation?: Maybe<AccountEVoucherStandardQuotationInformation>;
  totalUsedValue?: Maybe<Money>;
  type?: Maybe<AccountEVoucherType>;
  value?: Maybe<Money>;
}

export interface AccountEVoucherFleetQuotationInformation {
  __typename?: 'AccountEVoucherFleetQuotationInformation';
  estimatedExpirationDate?: Maybe<Scalars['Date']>;
  maxNumberOfValidMonths?: Maybe<Scalars['Int']>;
  maxValue?: Maybe<Money>;
  monthlyFee?: Maybe<Money>;
  quotationId: Scalars['String'];
  subContractId?: Maybe<Scalars['String']>;
  totalFleetContractCost?: Maybe<Money>;
}

export interface AccountEVoucherStandardQuotationInformation {
  __typename?: 'AccountEVoucherStandardQuotationInformation';
  estimatedExpirationDate?: Maybe<Scalars['Date']>;
  maxNumberOfValidMonths?: Maybe<Scalars['Int']>;
  maxValue?: Maybe<Money>;
  order?: Maybe<Order>;
  qualifyingQuoteValue?: Maybe<Money>;
  quotationId: Scalars['String'];
  totalQuoteValue?: Maybe<Money>;
}

export enum AccountEVoucherType {
  FLEET = 'FLEET',
  STANDARD = 'STANDARD'
}

export enum AccountType {
  BILL_TO = 'BILL_TO',
  SHIP_TO = 'SHIP_TO',
  SOLD_TO = 'SOLD_TO'
}

export interface Accreditor {
  __typename?: 'Accreditor';
  id: Scalars['ID'];
  numberOfCredits?: Maybe<Scalars['Float']>;
}

export interface ActivateCampaignEVoucherPayload {
  __typename?: 'ActivateCampaignEVoucherPayload';
  eVoucherId: Scalars['ID'];
}

export interface ActivateSoftwareSubscriptionInput {
  subscriptionId: Scalars['ID'];
}

export interface ActivateSoftwareSubscriptionPayload {
  __typename?: 'ActivateSoftwareSubscriptionPayload';
  subscriptionId: Scalars['ID'];
}

export interface Address {
  __typename?: 'Address';
  additionalGeoCode?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  company2?: Maybe<Scalars['String']>;
  company3?: Maybe<Scalars['String']>;
  company4?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  /** This field should not be used directly - added for internal use to be able to extend address with i18n Country */
  countryId?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  formatted?: Maybe<Array<Scalars['String']>>;
  postalcode?: Maybe<Scalars['String']>;
  region?: Maybe<Region>;
  /** This field should not be used directly - added for internal use to be able to extend address with i18n Region */
  regionId?: Maybe<Scalars['String']>;
  streetname?: Maybe<Scalars['String']>;
  streetname2?: Maybe<Scalars['String']>;
  streetname3?: Maybe<Scalars['String']>;
  streetname4?: Maybe<Scalars['String']>;
  streetname5?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
}

export interface AddressFormattedArgs {
  formType: FormType;
  localization: LocalizationInput;
}

export enum AddressCheckWarning {
  GENERAL = 'GENERAL',
  LEVEL2 = 'LEVEL2',
  LEVEL3 = 'LEVEL3'
}

export interface AddressSuggestion {
  __typename?: 'AddressSuggestion';
  id: Scalars['ID'];
  suggestion: Scalars['String'];
}

export interface AddressSuggestionFilterInput {
  country?: InputMaybe<Scalars['String']>;
  postalcode?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
}

export interface AddToCartInput {
  cartId: Scalars['ID'];
  fleetItems?: InputMaybe<Array<CartItemInput>>;
  peakItems?: InputMaybe<Array<CartPeakItemInput>>;
  softwareSubscriptionItems?: InputMaybe<Array<CartSubscriptionItemInput>>;
  standardItems?: InputMaybe<Array<CartItemInput>>;
  subscriptionItems?: InputMaybe<Array<CartSubscriptionItemInput>>;
}

export interface AddToCartItemErrorPayload {
  __typename?: 'AddToCartItemErrorPayload';
  productId: Scalars['ID'];
  quantity?: Maybe<Scalars['Float']>;
}

export interface AddToCartItemPayload {
  __typename?: 'AddToCartItemPayload';
  hasAdjustedQuantity: Scalars['Boolean'];
  product: Product;
  quantity: Scalars['Float'];
}

export interface AddToCartItemPayloadProductArgs {
  localization: LocalizationInput;
}

export interface AddToCartPayload {
  __typename?: 'AddToCartPayload';
  failedItems?: Maybe<Array<AddToCartItemErrorPayload>>;
  successfulItems?: Maybe<Array<AddToCartItemPayload>>;
}

export interface AddToShoppingListInput {
  items: Array<ShoppingListItemInput>;
  shoppingListId: Scalars['String'];
}

export interface AddToShoppingListPayload {
  __typename?: 'AddToShoppingListPayload';
  items?: Maybe<Array<Maybe<ShoppingListItem>>>;
}

export interface ApplyOrderDraftEVoucherInput {
  eVoucherCode: Scalars['String'];
  orderDraftId: Scalars['ID'];
}

export interface ApplyOrderDraftEVoucherPayload {
  __typename?: 'ApplyOrderDraftEVoucherPayload';
  orderDraft: OrderDraft;
}

export interface ApproveFleetQuotationInput {
  quotationId: Scalars['ID'];
}

export interface ApproveQuotationForRepairNotifications {
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  repairNotificationIds: Array<Scalars['String']>;
}

export interface AssignSoftwareSubscriptionContactInput {
  email: Scalars['String'];
  licenseActivationCode?: InputMaybe<Scalars['String']>;
  licenseGroupId?: InputMaybe<Scalars['Int']>;
  subscriptionId: Scalars['ID'];
}

export interface AssignSoftwareSubscriptionContactPayload {
  __typename?: 'AssignSoftwareSubscriptionContactPayload';
  user?: Maybe<LicenseUserAssignment>;
}

export interface AssignSoftwareSubscriptionContactsInput {
  emails: Array<Scalars['String']>;
  licenseActivationCode: Scalars['String'];
  licenseGroupId: Scalars['Int'];
  subscriptionId: Scalars['ID'];
}

export interface AssignSoftwareSubscriptionContactsPayload {
  __typename?: 'AssignSoftwareSubscriptionContactsPayload';
  statuses: Array<Maybe<SoftwareSubscriptionContactAssignmentStatus>>;
}

export interface Author {
  __typename?: 'Author';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface Banner extends Node {
  __typename?: 'Banner';
  body?: Maybe<Scalars['String']>;
  displayDelay?: Maybe<Scalars['Int']>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUri?: Maybe<Scalars['String']>;
  layout?: Maybe<BannerLayoutType>;
  links?: Maybe<Array<Link>>;
  mobileHeadline?: Maybe<Scalars['String']>;
  overline?: Maybe<Scalars['String']>;
  subHeadline?: Maybe<Scalars['String']>;
  webAnalyticsData?: Maybe<WebAnalyticsData>;
}

export enum BannerLayoutType {
  LIFESTYLE = 'LIFESTYLE',
  PRODUCT = 'PRODUCT'
}

export enum BatteriesExchangeLockType {
  IMMEDIATELY = 'IMMEDIATELY',
  ON_ORDER_CREATION = 'ON_ORDER_CREATION'
}

/** The BatterySelfRecyclingDocument is a type designed specifically for retrieval of battery self-recycling documents and should not be used in any different context */
export interface BatterySelfRecyclingDocument {
  __typename?: 'BatterySelfRecyclingDocument';
  url?: Maybe<Scalars['String']>;
}

export enum BillingCycle {
  FREE_OF_CHARGE = 'FREE_OF_CHARGE',
  MONTHLY = 'MONTHLY',
  SINGLE = 'SINGLE',
  YEARLY = 'YEARLY',
  YEARLY_AND_MONTHLY = 'YEARLY_AND_MONTHLY'
}

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export interface CalculateSoftwareSubscriptionPriceInput {
  calculateTax?: InputMaybe<Scalars['Boolean']>;
  effectiveDate?: InputMaybe<Scalars['Date']>;
  productId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  subscriptionId: Scalars['ID'];
  unitPrice?: InputMaybe<Scalars['BigDecimal']>;
}

export interface CalculateSoftwareSubscriptionPricePayload {
  __typename?: 'CalculateSoftwareSubscriptionPricePayload';
  currentUnitPrice?: Maybe<Money>;
  effectiveDate?: Maybe<Scalars['Date']>;
  price?: Maybe<Money>;
  proratedCharges?: Maybe<SubscriptionProratedCharges>;
  unitPrice?: Maybe<Money>;
}

export interface CallMeBackInput {
  country: Scalars['String'];
  fullName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  /** The user response token provided by the reCAPTCHA client-side integration. */
  token?: InputMaybe<Scalars['String']>;
}

export interface CallMeBackPayload {
  __typename?: 'CallMeBackPayload';
  conversationId: Scalars['ID'];
}

export interface CampaignEVoucherDetails {
  __typename?: 'CampaignEVoucherDetails';
  /** @deprecated Use TargetedCampaignEVoucherDetails.accountsFileName */
  accountsFileName?: Maybe<Scalars['String']>;
  campaignType?: Maybe<EVoucherCampaignType>;
  conditionTiers: Array<EVoucherConditionTier>;
  eligibleProducts?: Maybe<EVoucherProductsSelection>;
  maxNumberOfRedemptions?: Maybe<Scalars['Int']>;
  nonTargetedCampaignDetails?: Maybe<NonTargetedCampaignEVoucherDetails>;
  /** @deprecated Use TargetedCampaignEVoucherDetails.numberOfAccounts */
  numberOfAccounts?: Maybe<Scalars['Int']>;
  /** @deprecated Use TargetedCampaignEVoucherDetails.numberOfContacts */
  numberOfContacts?: Maybe<Scalars['Int']>;
  numberOfRedemptions?: Maybe<Scalars['Int']>;
  qualifyingProducts?: Maybe<EVoucherProductsSelection>;
  remainingNumberOfRedemptions?: Maybe<Scalars['Int']>;
  targetedCampaignDetails?: Maybe<TargetedCampaignEVoucherDetails>;
}

export interface CancelSoftwareSubscriptionInput {
  cancellationReason: Scalars['String'];
  effectiveDate?: InputMaybe<Scalars['Date']>;
  subscriptionId: Scalars['ID'];
}

export interface CancelSoftwareSubscriptionPayload {
  __typename?: 'CancelSoftwareSubscriptionPayload';
  softwareSubscription: SoftwareSubscription;
}

export interface Cart extends Node {
  __typename?: 'Cart';
  id: Scalars['ID'];
  numberOfItems?: Maybe<Scalars['Int']>;
}

export interface CartItemInput {
  productId: Scalars['String'];
  quantity: Scalars['Float'];
}

export interface CartPeakItemInput {
  productId: Scalars['String'];
  quantity: Scalars['Float'];
  rentalEndDate: Scalars['Date'];
  rentalStartDate: Scalars['Date'];
  useCurrentRentalPeriodForAllItems: Scalars['Boolean'];
}

export interface CartSubscriptionItemInput {
  billingCycle: Scalars['String'];
  productId: Scalars['String'];
  quantity: Scalars['Float'];
}

export enum CaseType {
  PROPERCASE = 'PROPERCASE',
  UPPERCASE = 'UPPERCASE'
}

export interface Category extends Node {
  __typename?: 'Category';
  /** List of subcategories */
  childCategories?: Maybe<Array<Category>>;
  /** Country isocode */
  country: Scalars['String'];
  /** Category long description */
  description?: Maybe<Scalars['String']>;
  /** Category id */
  id: Scalars['ID'];
  /** Language isocode */
  language: Scalars['String'];
  /** List of parent categories */
  path?: Maybe<Array<Category>>;
  /** URL providing category image of width: 200, height: 200 by default */
  thumbnail?: Maybe<Scalars['String']>;
  /** Category name */
  title?: Maybe<Scalars['String']>;
}

export interface CategoryThumbnailArgs {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface CategorySearch {
  __typename?: 'CategorySearch';
  id: Scalars['ID'];
  parent?: Maybe<CategorySearch>;
  title?: Maybe<Scalars['String']>;
}

export interface CheckAddressInput {
  caseType?: InputMaybe<CaseType>;
  country: Scalars['String'];
  language: Scalars['String'];
  postalcode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  streetname?: InputMaybe<Scalars['String']>;
  streetname2?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
}

export interface CheckAddressPayload {
  __typename?: 'CheckAddressPayload';
  originalAddress?: Maybe<Address>;
  suggestedAddress?: Maybe<Address>;
  warningCode?: Maybe<AddressCheckWarning>;
}

export interface CheckoutStoreConfiguration {
  __typename?: 'CheckoutStoreConfiguration';
  completeDelivery?: Maybe<Scalars['Boolean']>;
  customerDeliveryDateMonthLimit?: Maybe<Scalars['Int']>;
  customerFleetQuoteConversion?: Maybe<Scalars['Boolean']>;
  customerStandardQuoteConversion?: Maybe<Scalars['Boolean']>;
  employeeDeliveryDateMonthLimit?: Maybe<Scalars['Int']>;
  employeeFleetOrder?: Maybe<Scalars['Boolean']>;
  employeeFleetQuoteConversion?: Maybe<Scalars['Boolean']>;
  maxDiscountDeterminationRules?: Maybe<Array<Maybe<MaxDiscountDeterminationRule>>>;
  purchaseOrderDocument?: Maybe<Scalars['Boolean']>;
  purchaseOrderDocumentMandatory?: Maybe<Scalars['Boolean']>;
  purchaseOrderNumber?: Maybe<Scalars['Boolean']>;
  purchaseOrderNumberValidation?: Maybe<Scalars['Boolean']>;
  quickQuoteConversion?: Maybe<Scalars['Boolean']>;
  requestedDeliveryDateDaysAfter?: Maybe<Scalars['Int']>;
  requestedDeliveryDateDaysBefore?: Maybe<Scalars['Int']>;
}

export interface CircularityReport extends Node, Pageable {
  __typename?: 'CircularityReport';
  id: Scalars['ID'];
  year: Scalars['Int'];
}

export interface CircularityReportsPaginationResult extends PaginationResult {
  __typename?: 'CircularityReportsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<CircularityReport>>;
}

export interface CommonStoreConfiguration {
  __typename?: 'CommonStoreConfiguration';
  addressCheck?: Maybe<Scalars['Boolean']>;
  addressCheckCaseType?: Maybe<CaseType>;
  calendar?: Maybe<Scalars['Boolean']>;
  callMeBack?: Maybe<Scalars['Boolean']>;
  employeeCareNoteCreation?: Maybe<Scalars['Boolean']>;
  financialHubLimitedCapabilities?: Maybe<Scalars['Boolean']>;
  fireStopSubmittals?: Maybe<Scalars['Boolean']>;
  liveChat?: Maybe<Scalars['Boolean']>;
  personalInformationConsent?: Maybe<Scalars['Boolean']>;
  recentlyPurchasedItems?: Maybe<Scalars['Boolean']>;
  recommendedProducts?: Maybe<Scalars['Boolean']>;
  restrictedDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  sendUsAMessage?: Maybe<Scalars['Boolean']>;
  shipmentTracking?: Maybe<Scalars['Boolean']>;
  storeLocator?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['Boolean']>;
  weeklyOpeningSchedule?: Maybe<WeeklyOpeningSchedule>;
}

export enum CompletionStatus {
  FULL = 'FULL',
  NONE = 'NONE',
  PARTIAL = 'PARTIAL'
}

export interface Connection {
  edges: Array<Edge>;
  pageInfo: PageInfo;
}

export interface Contact extends Node, Pageable {
  __typename?: 'Contact';
  academicTitle?: Maybe<ContactAcademicTitle>;
  authorizedForHiltiOnline?: Maybe<Scalars['Boolean']>;
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formatted?: Maybe<Array<Scalars['String']>>;
  function?: Maybe<ContactFunction>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  originId: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<ContactTitle>;
}

export interface ContactFormattedArgs {
  formType: FormType;
  localization: LocalizationInput;
}

export interface ContactAcademicTitle extends Localizable {
  __typename?: 'ContactAcademicTitle';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface ContactAcademicTitleNameArgs {
  localization: LocalizationInput;
}

export interface ContactConnection extends Connection {
  __typename?: 'ContactConnection';
  edges: Array<ContactEdge>;
  pageInfo: PageInfo;
}

export interface ContactEdge extends Edge {
  __typename?: 'ContactEdge';
  cursor?: Maybe<Scalars['String']>;
  node: Contact;
}

export interface ContactFunction extends Localizable {
  __typename?: 'ContactFunction';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface ContactFunctionNameArgs {
  localization: LocalizationInput;
}

export interface ContactsAssignableToSubscriptionInput {
  emails?: InputMaybe<Array<Scalars['String']>>;
}

export interface ContactsAssignableToSubscriptionPayload {
  __typename?: 'ContactsAssignableToSubscriptionPayload';
  emailsAssignable?: Maybe<Array<Scalars['String']>>;
  emailsNotAssignable?: Maybe<Array<Scalars['String']>>;
}

export interface ContactTitle extends Localizable {
  __typename?: 'ContactTitle';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface ContactTitleNameArgs {
  localization: LocalizationInput;
}

export interface CopyCompanyToPrivateShoppingListInput {
  companyShoppingListId: Scalars['String'];
  privateShoppingList: CreatePrivateShoppingListInput;
}

export interface CopyCompanyToPrivateShoppingPayload {
  __typename?: 'CopyCompanyToPrivateShoppingPayload';
  shoppingList?: Maybe<ShoppingList>;
}

export interface CopyPrivateToCompanyShoppingListInput {
  companyShoppingList: CreateCompanyShoppingListInput;
  privateShoppingListId: Scalars['String'];
}

export interface CopyPrivateToCompanyShoppingPayload {
  __typename?: 'CopyPrivateToCompanyShoppingPayload';
  shoppingList?: Maybe<ShoppingList>;
}

export interface Country extends Localizable {
  __typename?: 'Country';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface CountryNameArgs {
  localization: LocalizationInput;
}

export interface CreateAccountEVoucherInput {
  eVoucherValue: Scalars['BigDecimal'];
  quotationId: Scalars['String'];
  type: AccountEVoucherType;
}

export interface CreateAccountEVoucherPayload {
  __typename?: 'CreateAccountEVoucherPayload';
  eVoucher: EVoucher;
}

export interface CreateCampaignEVoucherInput {
  campaignType?: InputMaybe<EVoucherCampaignType>;
  eVoucherCode: Scalars['String'];
}

export interface CreateCampaignEVoucherPayload {
  __typename?: 'CreateCampaignEVoucherPayload';
  eVoucher: EVoucher;
}

export interface CreateCartInput {
  localization: LocalizationInput;
}

export interface CreateCartPayload {
  __typename?: 'CreateCartPayload';
  cart: Cart;
}

export interface CreateCompanyShoppingListInput {
  accountId: Scalars['String'];
  contactId?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  name: Scalars['String'];
}

export interface CreateContactInput {
  academicTitle?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  function: Scalars['String'];
  language: Scalars['String'];
  lastName: Scalars['String'];
  mobile?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

export interface CreateContactPayload {
  __typename?: 'CreateContactPayload';
  contact?: Maybe<Contact>;
}

export interface CreateCustomerCareNoteInput {
  complaint: Scalars['String'];
  expectation: Scalars['String'];
  invoiceNumber?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  referenceDeliveryNumber?: InputMaybe<Scalars['String']>;
}

export interface CreateEContractInput {
  eContractView: EContractViewInput;
  templateId: Scalars['ID'];
}

export interface CreateLegacySoftwareSubscriptionMasterAgreementInput {
  subscriptionId: Scalars['ID'];
}

export interface CreateLegacySoftwareSubscriptionMasterAgreementPayload {
  __typename?: 'CreateLegacySoftwareSubscriptionMasterAgreementPayload';
  eContract?: Maybe<EContract>;
}

export interface CreatePrivateShoppingListInput {
  contactId?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  name: Scalars['String'];
}

export interface CreateShippingAddressInput {
  additionalGeoCode?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  company2?: InputMaybe<Scalars['String']>;
  company3?: InputMaybe<Scalars['String']>;
  company4?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  district?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
  postalcode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  streetname?: InputMaybe<Scalars['String']>;
  streetname2?: InputMaybe<Scalars['String']>;
  streetname3?: InputMaybe<Scalars['String']>;
  streetname4?: InputMaybe<Scalars['String']>;
  streetname5?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
  validated?: InputMaybe<Scalars['Boolean']>;
}

export interface CreateShippingAddressPayload {
  __typename?: 'CreateShippingAddressPayload';
  shippingAddress?: Maybe<Account>;
}

export interface CreateShoppingListPayload {
  __typename?: 'CreateShoppingListPayload';
  shoppingList?: Maybe<ShoppingList>;
}

export interface CreateSoftwareSubscriptionMasterAgreementAmendmentInput {
  effectiveDate?: InputMaybe<Scalars['Date']>;
  productId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  subscriptionId: Scalars['ID'];
  subscriptionVersion: Scalars['Int'];
  unitPrice?: InputMaybe<Scalars['BigDecimal']>;
}

export interface CreateSoftwareSubscriptionMasterAgreementAmendmentPayload {
  __typename?: 'CreateSoftwareSubscriptionMasterAgreementAmendmentPayload';
  eContract?: Maybe<EContract>;
}

export interface CreditCardDetails {
  __typename?: 'CreditCardDetails';
  expirationDate: Scalars['Date'];
  holderName?: Maybe<Scalars['String']>;
  lastDigits: Scalars['String'];
  type: CreditCardType;
}

export enum CreditCardType {
  AMEX = 'AMEX',
  DISCOVER = 'DISCOVER',
  MASTERCARD = 'MASTERCARD',
  OTHER = 'OTHER',
  VISA = 'VISA'
}

export interface CurrencyExchangeRate {
  __typename?: 'CurrencyExchangeRate';
  exchangeRateFrom?: Maybe<Scalars['Float']>;
  exchangeRateTo?: Maybe<Scalars['Float']>;
}

export interface Customer extends Node, UserContext {
  __typename?: 'Customer';
  companyAccount: Account;
  contact: Contact;
  defaultBillToAccount?: Maybe<Account>;
  defaultShipToAccount?: Maybe<Account>;
  email: Scalars['String'];
  fleetMasterContract?: Maybe<FleetMasterContract>;
  id: Scalars['ID'];
  permissions?: Maybe<Array<Scalars['String']>>;
  /** This is the role assigned to the customer coming from the HC-Claim-HOL-Permissions header token. The default value for the role is 'buyer'. */
  role?: Maybe<Scalars['String']>;
}

export interface CustomerFleetMasterContractArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNote extends Pageable {
  __typename?: 'CustomerCareNote';
  afterMarketServiceNotificationNumber?: Maybe<Scalars['String']>;
  careNoteClass?: Maybe<CustomerCareNoteClass>;
  careNoteSubtype?: Maybe<CustomerCareNoteSubtype>;
  careNoteType?: Maybe<CustomerCareNoteType>;
  closedAt?: Maybe<Scalars['DateTime']>;
  complaint?: Maybe<Scalars['String']>;
  contact?: Maybe<Contact>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerCareNotificationNumber?: Maybe<Scalars['String']>;
  disputedValue?: Maybe<Money>;
  employeeClosedBy?: Maybe<Scalars['String']>;
  employeeHandledBy?: Maybe<Scalars['String']>;
  employeeReceivedBy?: Maybe<Scalars['String']>;
  employeeRecordedBy?: Maybe<Scalars['String']>;
  expectation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  referenceDeliveryNumber?: Maybe<Scalars['String']>;
  status?: Maybe<CustomerCareNoteStatus>;
  tasks?: Maybe<Array<Maybe<CustomerCareNoteTask>>>;
  toolSerialNumber?: Maybe<Scalars['String']>;
}

export interface CustomerCareNoteClass extends Localizable {
  __typename?: 'CustomerCareNoteClass';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface CustomerCareNoteClassNameArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNoteOrderByInput {
  afterMarketServiceNotificationNumber?: InputMaybe<Sort>;
  careNoteClass?: InputMaybe<Sort>;
  careNoteSubtype?: InputMaybe<Sort>;
  careNoteType?: InputMaybe<Sort>;
  closedAt?: InputMaybe<Sort>;
  contact?: InputMaybe<Sort>;
  createdAt?: InputMaybe<Sort>;
  customerCareNotificationNumber?: InputMaybe<Sort>;
  customerNumber?: InputMaybe<Sort>;
  disputedCurrency?: InputMaybe<Sort>;
  disputedValue?: InputMaybe<Sort>;
  employeeClosedBy?: InputMaybe<Sort>;
  employeeHandledBy?: InputMaybe<Sort>;
  employeeReceivedBy?: InputMaybe<Sort>;
  employeeRecordedBy?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  invoiceNumber?: InputMaybe<Sort>;
  orderNumber?: InputMaybe<Sort>;
  productId?: InputMaybe<Sort>;
  purchaseOrderNumber?: InputMaybe<Sort>;
  receivedAt?: InputMaybe<Sort>;
  referenceDeliveryNumber?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  toolSerialNumber?: InputMaybe<Sort>;
}

export interface CustomerCareNotePaginationResult extends PaginationResult {
  __typename?: 'CustomerCareNotePaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<CustomerCareNote>>;
}

export interface CustomerCareNotePayload {
  __typename?: 'CustomerCareNotePayload';
  careNote: CustomerCareNote;
}

export interface CustomerCareNoteStatus extends Localizable {
  __typename?: 'CustomerCareNoteStatus';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface CustomerCareNoteStatusNameArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNoteSubtype extends Localizable {
  __typename?: 'CustomerCareNoteSubtype';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface CustomerCareNoteSubtypeNameArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNoteTask {
  __typename?: 'CustomerCareNoteTask';
  closedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  doneAt?: Maybe<Scalars['DateTime']>;
  employeeClosedBy?: Maybe<Scalars['String']>;
  employeeCreatedBy?: Maybe<Scalars['String']>;
  employeeDoneBy?: Maybe<Scalars['String']>;
  employeeUpdatedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  responsibleDepartment?: Maybe<Department>;
  responsiblePerson?: Maybe<Scalars['String']>;
  status?: Maybe<CustomerCareNoteTaskStatus>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
}

export interface CustomerCareNoteTaskStatus extends Localizable {
  __typename?: 'CustomerCareNoteTaskStatus';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface CustomerCareNoteTaskStatusNameArgs {
  localization: LocalizationInput;
}

export interface CustomerCareNoteType extends Localizable {
  __typename?: 'CustomerCareNoteType';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface CustomerCareNoteTypeNameArgs {
  localization: LocalizationInput;
}

export interface CustomerEVoucherRestrictions {
  __typename?: 'CustomerEVoucherRestrictions';
  isAllowedToUseAccountEVouchers?: Maybe<Scalars['Boolean']>;
  isAllowedToUseCampaignEVouchers?: Maybe<Scalars['Boolean']>;
}

export interface CustomerPricesFilterInput {
  currency?: InputMaybe<Scalars['String']>;
  products: Array<ProductPriceInput>;
  shipToAccountId?: InputMaybe<Scalars['String']>;
  types: Array<PriceType>;
}

export enum CustomerServiceMessageStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export enum CustomerType {
  BUSINESS = 'BUSINESS',
  INDIVIDUAL = 'INDIVIDUAL'
}

export interface DailyOpeningSchedule {
  __typename?: 'DailyOpeningSchedule';
  day: Day;
  open?: Maybe<Scalars['Boolean']>;
  workingHours?: Maybe<Array<TimeRange>>;
}

export enum Day {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export interface DeactivateEVoucherPayload {
  __typename?: 'DeactivateEVoucherPayload';
  eVoucherId: Scalars['ID'];
}

export interface DeclineSoftwareSubscriptionMasterAgreementAmendmentInput {
  eContractId: Scalars['ID'];
}

export interface DeclineSoftwareSubscriptionMasterAgreementAmendmentPayload {
  __typename?: 'DeclineSoftwareSubscriptionMasterAgreementAmendmentPayload';
  subscriptionId: Scalars['ID'];
}

export interface DelayedBillingInformation {
  __typename?: 'DelayedBillingInformation';
  months?: Maybe<Scalars['Int']>;
  reason?: Maybe<DelayedBillingReason>;
}

export enum DelayedBillingReason {
  SALES_TACTICS = 'SALES_TACTICS'
}

export interface DeleteOrderDraftPurchaseOrderDocumentInput {
  orderDraftId: Scalars['ID'];
  purchaseOrderDocumentId: Scalars['String'];
}

export interface DeleteOrderDraftPurchaseOrderDocumentPayload {
  __typename?: 'DeleteOrderDraftPurchaseOrderDocumentPayload';
  orderDraft: OrderDraft;
}

export interface DeleteShoppingListPayload {
  __typename?: 'DeleteShoppingListPayload';
  id: Scalars['ID'];
}

export interface DeleteSoftwareSubscriptionInput {
  subscriptionId: Scalars['ID'];
}

export interface DeleteSoftwareSubscriptionPayload {
  __typename?: 'DeleteSoftwareSubscriptionPayload';
  subscriptionId: Scalars['ID'];
}

export interface DeliveryInformation {
  __typename?: 'DeliveryInformation';
  carrierInstructions?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  deliveryMethod?: Maybe<DeliveryMethod>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  isSingleShipment?: Maybe<Scalars['Boolean']>;
}

export interface DeliveryMethod extends Localizable {
  __typename?: 'DeliveryMethod';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface DeliveryMethodNameArgs {
  localization: LocalizationInput;
}

export interface DeliveryMethodShippingDetails {
  __typename?: 'DeliveryMethodShippingDetails';
  calculationInProgress?: Maybe<Scalars['Boolean']>;
  dates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  deliveryMethod: DeliveryMethod;
  hasApproximatedShippingCharges?: Maybe<Scalars['Boolean']>;
  isAllowedToChooseDeliveryDate?: Maybe<Scalars['Boolean']>;
  maxRequestDeliveryDate?: Maybe<Scalars['Date']>;
  minRequestDeliveryDate?: Maybe<Scalars['Date']>;
  shippingCharges?: Maybe<Money>;
}

export interface DeliveryStatus extends Localizable {
  __typename?: 'DeliveryStatus';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface DeliveryStatusNameArgs {
  localization: LocalizationInput;
}

export interface DeliveryType {
  __typename?: 'DeliveryType';
  id: Scalars['ID'];
}

export interface Department extends Localizable {
  __typename?: 'Department';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface DepartmentNameArgs {
  localization: LocalizationInput;
}

export interface Dimension {
  __typename?: 'Dimension';
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface Discount {
  __typename?: 'Discount';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['BigDecimal']>;
  value?: Maybe<Scalars['BigDecimal']>;
}

export enum DistanceUnit {
  KM = 'KM',
  MI = 'MI'
}

export interface EContract extends Node {
  __typename?: 'EContract';
  fields?: Maybe<Array<EContractField>>;
  id: Scalars['ID'];
  iframeUrl?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['String']>;
}

export interface EContractField extends Node {
  __typename?: 'EContractField';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  validation?: Maybe<EContractFieldValidation>;
  value?: Maybe<Scalars['String']>;
}

export interface EContractFieldInput {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
}

export interface EContractFieldValidation {
  __typename?: 'EContractFieldValidation';
  isRequired?: Maybe<Scalars['Boolean']>;
  maxLength?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  pattern?: Maybe<Scalars['String']>;
}

export interface EContractIframeUrlInput {
  eContractId: Scalars['ID'];
  returnUri: Scalars['String'];
}

export interface EContractPayload {
  __typename?: 'EContractPayload';
  eContract: EContract;
}

export interface EContractTemplate extends Node {
  __typename?: 'EContractTemplate';
  fields?: Maybe<Array<EContractField>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface EContractViewInput {
  fields?: InputMaybe<Array<EContractFieldInput>>;
  isViewPortEnabled?: InputMaybe<Scalars['Boolean']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  returnUri: Scalars['String'];
}

export interface Edge {
  cursor?: Maybe<Scalars['String']>;
  node: Node;
}

export interface EducationTeaser extends Node {
  __typename?: 'EducationTeaser';
  body?: Maybe<Scalars['String']>;
  headline: Scalars['String'];
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUri?: Maybe<Scalars['String']>;
  linkUri: Scalars['String'];
}

export interface Employee extends Node, UserContext {
  __typename?: 'Employee';
  customerCompanyAccount?: Maybe<Account>;
  customerContact?: Maybe<Contact>;
  customerFleetMasterContract?: Maybe<FleetMasterContract>;
  email: Scalars['String'];
  id: Scalars['ID'];
  role?: Maybe<Role>;
  type?: Maybe<EmployeeType>;
}

export interface EmployeeCustomerFleetMasterContractArgs {
  localization: LocalizationInput;
}

export enum EmployeeType {
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  EVOUCHER_BACKOFFICE_USER = 'EVOUCHER_BACKOFFICE_USER'
}

export interface EntryPriceInformation {
  __typename?: 'EntryPriceInformation';
  pricePerUnit?: Maybe<Money>;
  priceQuantity?: Maybe<Scalars['Float']>;
  priceUnitOfMeasure?: Maybe<UnitOfMeasure>;
  totalPrice?: Maybe<Money>;
}

export interface EVoucher extends Node, Pageable {
  __typename?: 'EVoucher';
  accountDetails?: Maybe<AccountEVoucherDetails>;
  campaignDetails?: Maybe<CampaignEVoucherDetails>;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  creationDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  status?: Maybe<EVoucherStatus>;
  type: EVoucherType;
  validFrom?: Maybe<Scalars['Date']>;
  validTo?: Maybe<Scalars['Date']>;
}

export interface EVoucherAccountsAdministrationConfiguration {
  __typename?: 'EVoucherAccountsAdministrationConfiguration';
  accountRestrictedAccounts: Array<Account>;
  campaignRestrictedAccounts: Array<Account>;
}

export interface EVoucherAdministrationConfiguration {
  __typename?: 'EVoucherAdministrationConfiguration';
  fleetAccountEVoucherAdministrationConfiguration?: Maybe<AccountEVoucherAdministrationConfiguration>;
  fleetAccountEVoucherEligibleProductsInformation?: Maybe<EVoucherProductSelectionInformation>;
  numberOfAccountEVoucherRestrictedAccounts?: Maybe<Scalars['Int']>;
  numberOfCampaignEVoucherRestrictedAccounts?: Maybe<Scalars['Int']>;
  /** @deprecated Use restrictedProductInformation.numberOfCategories */
  numberOfRestrictedCategories?: Maybe<Scalars['Int']>;
  /** @deprecated Use restrictedProductInformation.numberOfProducts */
  numberOfRestrictedProducts?: Maybe<Scalars['Int']>;
  /** @deprecated Use restrictedProductInformation.numberOfTypes */
  numberOfRestrictedTypes?: Maybe<Scalars['Int']>;
  restrictedProductInformation?: Maybe<EVoucherProductSelectionInformation>;
  standardAccountEVoucherAdministrationConfiguration?: Maybe<AccountEVoucherAdministrationConfiguration>;
  standardAccountEVoucherEligibleProductsInformation?: Maybe<EVoucherProductSelectionInformation>;
}

export interface EVoucherCampaignReportState {
  __typename?: 'EVoucherCampaignReportState';
  creationDate?: Maybe<Scalars['Date']>;
  /** This field contains information if final version of the report is available, if true no more report generation requests are allowed */
  isFinalVersionAvailable?: Maybe<Scalars['Boolean']>;
  /** This field contains information if report is generating in current point in time */
  isNewVersionBeingGenerated?: Maybe<Scalars['Boolean']>;
}

export enum EVoucherCampaignType {
  NON_TARGETED = 'NON_TARGETED',
  TARGETED = 'TARGETED'
}

export interface EVoucherConditionTier {
  __typename?: 'EVoucherConditionTier';
  cartTotal?: Maybe<Scalars['BigDecimal']>;
  discount?: Maybe<Discount>;
  productsValue?: Maybe<Scalars['BigDecimal']>;
}

export interface EVoucherFilterInput {
  query?: InputMaybe<Scalars['String']>;
  restrictions?: InputMaybe<Array<EVoucherFilterRestriction>>;
  type?: InputMaybe<EVoucherType>;
}

export enum EVoucherFilterRestriction {
  CREATED_BY_CURRENT_EMPLOYEE = 'CREATED_BY_CURRENT_EMPLOYEE',
  CURRENT_CUSTOMER = 'CURRENT_CUSTOMER'
}

export interface EVoucherListReportState {
  __typename?: 'EVoucherListReportState';
  creationDate?: Maybe<Scalars['Date']>;
  /** This field contains information if report is generating in current point in time */
  isNewVersionBeingGenerated?: Maybe<Scalars['Boolean']>;
}

export interface EVoucherListReportStateFilterInput {
  type: EVoucherType;
}

export interface EVoucherMarketingConsents {
  __typename?: 'EVoucherMarketingConsents';
  areEventsAndPromotionsRequired?: Maybe<Scalars['Boolean']>;
  isCustomerFeedbackRequired?: Maybe<Scalars['Boolean']>;
  isNewsletterRequired?: Maybe<Scalars['Boolean']>;
  isPhoneRequired?: Maybe<Scalars['Boolean']>;
  isSocialNetworkRequired?: Maybe<Scalars['Boolean']>;
  isTechnicalEducationRequired?: Maybe<Scalars['Boolean']>;
}

export interface EVoucherPaginationResult extends PaginationResult {
  __typename?: 'EVoucherPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<EVoucher>>;
}

export interface EVoucherProductsAdministrationConfiguration {
  __typename?: 'EVoucherProductsAdministrationConfiguration';
  fleetAccountEligibleProducts: Array<EVoucherProductSelection>;
  restrictedProducts: Array<EVoucherProductSelection>;
  standardAccountEligibleProducts: Array<EVoucherProductSelection>;
}

export interface EVoucherProductSelection {
  __typename?: 'EVoucherProductSelection';
  id: Scalars['String'];
  type: EVoucherProductSelectionType;
}

export interface EVoucherProductSelectionInformation {
  __typename?: 'EVoucherProductSelectionInformation';
  numberOfCategories?: Maybe<Scalars['Int']>;
  numberOfProducts?: Maybe<Scalars['Int']>;
  /** The number of selected product types e.g. 'Tool', 'Accessory' */
  numberOfTypes?: Maybe<Scalars['Int']>;
}

export enum EVoucherProductSelectionType {
  CATEGORY = 'CATEGORY',
  PRODUCT = 'PRODUCT',
  TYPE = 'TYPE'
}

export interface EVoucherProductsSelection {
  __typename?: 'EVoucherProductsSelection';
  excludedProducts: Array<EVoucherProductSelection>;
  includedProducts: Array<EVoucherProductSelection>;
}

export interface EVoucherRedemptionInformation {
  __typename?: 'EVoucherRedemptionInformation';
  date?: Maybe<Scalars['Date']>;
  order?: Maybe<Order>;
  value?: Maybe<Money>;
}

export enum EVoucherReportGenerationStatus {
  ERROR = 'ERROR',
  ERROR_REPORT_IN_PROGRESS = 'ERROR_REPORT_IN_PROGRESS',
  ERROR_TIMEOUT_REQUIRED = 'ERROR_TIMEOUT_REQUIRED',
  SUCCESS = 'SUCCESS'
}

export interface EVoucherRestrictedAccountsConfigurationPaginationResult {
  __typename?: 'EVoucherRestrictedAccountsConfigurationPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Account>;
}

export interface EVoucherRestrictedAccountsFilterInput {
  query?: InputMaybe<Scalars['String']>;
}

export enum EVoucherStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  PROCESSING = 'PROCESSING',
  REDEEMED = 'REDEEMED'
}

export interface EVoucherStoreConfiguration {
  __typename?: 'EVoucherStoreConfiguration';
  isPartialRedemptionEnabled?: Maybe<Scalars['Boolean']>;
  isStandardQuotationEnabled?: Maybe<Scalars['Boolean']>;
}

export enum EVoucherType {
  ACCOUNT = 'ACCOUNT',
  CAMPAIGN = 'CAMPAIGN'
}

export interface ExchangeableBatteriesFilterInput {
  groups?: InputMaybe<Array<InputMaybe<ToolGroup>>>;
}

export enum ExchangeCycle {
  ANNUALLY = 'ANNUALLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMI_ANNUALLY = 'SEMI_ANNUALLY'
}

export interface ExchangeOption {
  __typename?: 'ExchangeOption';
  exchangeCycle?: Maybe<ExchangeCycle>;
  exchangeMonth?: Maybe<Scalars['Int']>;
}

export interface FleetDetails {
  __typename?: 'FleetDetails';
  contractEndDate?: Maybe<Scalars['Date']>;
  contractStartDate?: Maybe<Scalars['Date']>;
  costCenter?: Maybe<Scalars['String']>;
  fleetSubContract?: Maybe<FleetSubContract>;
  inventoryNumber?: Maybe<Scalars['String']>;
  monthlyFee?: Maybe<Money>;
  organizationalReference?: Maybe<Scalars['String']>;
  totalUsagePeriod?: Maybe<Scalars['Int']>;
  usagePeriod?: Maybe<Scalars['Int']>;
}

export enum FleetEContractStatus {
  ACCEPTED = 'ACCEPTED',
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED',
  HI_SIGNED = 'HI_SIGNED',
  QUOTATION = 'QUOTATION',
  REJECTED = 'REJECTED',
  SIGNED = 'SIGNED',
  STARTED = 'STARTED',
  UPDATED = 'UPDATED'
}

export interface FleetEContractTemplateFilterInput {
  templateId?: InputMaybe<Scalars['String']>;
  templateName?: InputMaybe<FleetEContractTemplateNameFilterInput>;
}

export interface FleetEContractTemplateNameFilterInput {
  fleetContractType: Scalars['String'];
  fleetContractVersion: Scalars['String'];
  hasTheftCoverage?: InputMaybe<Scalars['Boolean']>;
  localization: LocalizationInput;
}

export interface FleetInvoiceOptions {
  __typename?: 'FleetInvoiceOptions';
  invoiceGroupedBy?: Maybe<Array<Maybe<InvoiceOption>>>;
  invoiceSplitBy?: Maybe<Array<Maybe<InvoiceOption>>>;
}

export interface FleetLabelingTemplate extends Node {
  __typename?: 'FleetLabelingTemplate';
  id: Scalars['ID'];
  isCustomerLogoVisible?: Maybe<Scalars['Boolean']>;
  isCustomerNameVisible?: Maybe<Scalars['Boolean']>;
  isInventoryNumberVisible?: Maybe<Scalars['Boolean']>;
  isOrganizationalReferenceVisible?: Maybe<Scalars['Boolean']>;
  isSerialNumberVisible?: Maybe<Scalars['Boolean']>;
  orientation?: Maybe<FleetLabelingTemplateOrientation>;
  type?: Maybe<FleetLabelType>;
}

export enum FleetLabelingTemplateOrientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT'
}

export enum FleetLabelType {
  DIGITAL = 'DIGITAL',
  DIGITAL_PHYSICAL = 'DIGITAL_PHYSICAL',
  PHYSICAL = 'PHYSICAL'
}

export interface FleetMasterContract extends Node {
  __typename?: 'FleetMasterContract';
  customerLogoUri?: Maybe<Scalars['String']>;
  exchangeCycle?: Maybe<ExchangeCycle>;
  exchangeMonth?: Maybe<Scalars['Int']>;
  fleetLabelingTemplate?: Maybe<FleetLabelingTemplate>;
  id: Scalars['ID'];
  invoiceGroupedBy?: Maybe<InvoiceOption>;
  invoiceSplitBy?: Maybe<InvoiceOption>;
  isCostCenterRequired?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentTerms?: Maybe<PaymentTerms>;
  status?: Maybe<FleetMasterContractStatus>;
}

export interface FleetMasterContractFleetLabelingTemplateArgs {
  localization: LocalizationInput;
}

export interface FleetMasterContractOptions {
  __typename?: 'FleetMasterContractOptions';
  availableCostCenters?: Maybe<Array<Maybe<Scalars['String']>>>;
  availableOrganizationalReferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  exchangeOptions?: Maybe<Array<Maybe<ExchangeOption>>>;
  fleetLabelingTemplates: Array<Maybe<FleetLabelingTemplate>>;
  fleetLabelType: FleetLabelType;
  invoiceGroupedBy?: Maybe<Array<Maybe<InvoiceOption>>>;
  invoiceSplitBy?: Maybe<Array<Maybe<InvoiceOption>>>;
}

export enum FleetMasterContractStatus {
  ACTIVE = 'ACTIVE',
  BANKRUPTCY = 'BANKRUPTCY',
  INACTIVE = 'INACTIVE',
  PREPARE = 'PREPARE',
  QUOTATION = 'QUOTATION',
  TERMINATED = 'TERMINATED',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS'
}

export interface FleetOrderEntry extends GenericOrderEntry {
  __typename?: 'FleetOrderEntry';
  comboChildren?: Maybe<Array<StandardOrderEntry>>;
  entryNumber: Scalars['Int'];
  fcpTax?: Maybe<Money>;
  fleetDetails?: Maybe<FleetDetails>;
  icmsTax?: Maybe<Money>;
  ipiTax?: Maybe<Money>;
  item?: Maybe<Product>;
  quantity?: Maybe<Scalars['Float']>;
}

export interface FleetOrderEntryItemArgs {
  localization: LocalizationInput;
}

export interface FleetOrganizationalReferencesAndCostCenters {
  __typename?: 'FleetOrganizationalReferencesAndCostCenters';
  costCenters?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationalReferences?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface FleetPremiumServices {
  __typename?: 'FleetPremiumServices';
  hasLoanTools?: Maybe<Scalars['Boolean']>;
  hasPeakTools?: Maybe<Scalars['Boolean']>;
  hasTheftCoverage?: Maybe<Scalars['Boolean']>;
}

export interface FleetPrice {
  __typename?: 'FleetPrice';
  monthlyFee: Scalars['BigDecimal'];
  upfrontCost: Scalars['BigDecimal'];
}

export interface FleetPriceDetails {
  __typename?: 'FleetPriceDetails';
  period: Scalars['Int'];
  salesPriceInformation: FleetPrice;
  unitPriceInformation: FleetPrice;
}

export interface FleetQuotation extends GenericOrder, Node, Pageable {
  __typename?: 'FleetQuotation';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  date?: Maybe<Scalars['Date']>;
  delayedBillingInformation?: Maybe<DelayedBillingInformation>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<FleetOrderEntry>;
  expirationDate?: Maybe<Scalars['Date']>;
  fleetEContract?: Maybe<EContract>;
  fleetEContractStatus?: Maybe<FleetEContractStatus>;
  fleetSubContract?: Maybe<FleetSubContract>;
  id: Scalars['ID'];
  paymentMethod?: Maybe<PaymentMethod>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<SalesChannel>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  soldTo?: Maybe<Customer>;
  status?: Maybe<QuotationStatus>;
  totalPrice?: Maybe<Money>;
}

export interface FleetQuotationPaginationResult extends PaginationResult {
  __typename?: 'FleetQuotationPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<FleetQuotation>>;
}

export interface FleetStoreConfiguration {
  __typename?: 'FleetStoreConfiguration';
  delayedBilling?: Maybe<Scalars['Boolean']>;
  inventoryNumberLength?: Maybe<Scalars['Int']>;
  organisationalReferenceLength?: Maybe<Scalars['Int']>;
  quotationEContractingProcess?: Maybe<Scalars['Boolean']>;
}

export interface FleetSubContract extends Node {
  __typename?: 'FleetSubContract';
  /** Id will be quotation until we get the proper information from Cloud */
  id: Scalars['ID'];
  parentContract?: Maybe<FleetMasterContract>;
  premiumServices?: Maybe<FleetPremiumServices>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
}

export interface FormConfiguration extends Node {
  __typename?: 'FormConfiguration';
  fields: Array<FormFieldConfiguration>;
  id: Scalars['ID'];
}

export interface FormFieldConfiguration extends Node {
  __typename?: 'FormFieldConfiguration';
  hiddenOnForm?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  readOnly?: Maybe<Scalars['Boolean']>;
  type?: Maybe<FormFieldType>;
  upperCase?: Maybe<Scalars['Boolean']>;
  validation?: Maybe<FormFieldValidation>;
  values?: Maybe<Array<FormFieldValue>>;
}

export interface FormFieldConfigurationValuesArgs {
  localization: LocalizationInput;
}

export enum FormFieldType {
  DROPDOWN = 'DROPDOWN',
  STRING = 'STRING'
}

export interface FormFieldValidation {
  __typename?: 'FormFieldValidation';
  maxLength?: Maybe<Scalars['Int']>;
  pattern?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
}

export interface FormFieldValue extends Node {
  __typename?: 'FormFieldValue';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export enum FormType {
  ADDRESS = 'ADDRESS',
  ADDRESS_DISPLAY = 'ADDRESS_DISPLAY',
  CONTACT_DISPLAY = 'CONTACT_DISPLAY',
  GUEST_CHECKOUT_BILLING_DETAILS = 'GUEST_CHECKOUT_BILLING_DETAILS',
  GUEST_CHECKOUT_SHIPPING_DETAILS = 'GUEST_CHECKOUT_SHIPPING_DETAILS',
  NEW_CONTACT = 'NEW_CONTACT',
  PROFILE_COMPANY = 'PROFILE_COMPANY',
  PROFILE_CONTACT = 'PROFILE_CONTACT'
}

export interface GenerateCircularityReportInput {
  localization: LocalizationInput;
  year: Scalars['Int'];
}

export interface GenerateCircularityReportPayload {
  __typename?: 'GenerateCircularityReportPayload';
  url: Scalars['String'];
}

export interface GenerateEVoucherCampaignReportPayload {
  __typename?: 'GenerateEVoucherCampaignReportPayload';
  eVoucherId: Scalars['ID'];
}

export interface GenerateEVoucherListReportInput {
  type: EVoucherType;
}

export interface GenerateEVoucherListReportPayload {
  __typename?: 'GenerateEVoucherListReportPayload';
  status?: Maybe<EVoucherReportGenerationStatus>;
}

export interface GenerateRapidPayAccessTokenPayload {
  __typename?: 'GenerateRapidPayAccessTokenPayload';
  accessToken: Scalars['JWT'];
}

export interface GenerateSubscriptionAmendmentEContractIframeUrlInput {
  returnUri: Scalars['String'];
  subscriptionId: Scalars['ID'];
}

/** A GenericOrder is a base line for orders and quotations */
export interface GenericOrder {
  billToAccount?: Maybe<Account>;
  date?: Maybe<Scalars['Date']>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<GenericOrderEntry>;
  id: Scalars['ID'];
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  soldTo?: Maybe<Customer>;
  totalPrice?: Maybe<Money>;
}

export interface GenericOrderEntry {
  entryNumber: Scalars['Int'];
  item?: Maybe<Product>;
  quantity?: Maybe<Scalars['Float']>;
}

export interface GenericOrderEntryItemArgs {
  localization: LocalizationInput;
}

export interface GeoLocation {
  __typename?: 'GeoLocation';
  accuracy?: Maybe<Scalars['Float']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
}

export interface HiltiCenter extends Node {
  __typename?: 'HiltiCenter';
  address?: Maybe<Address>;
  id: Scalars['ID'];
  location?: Maybe<GeoLocation>;
  name?: Maybe<Scalars['String']>;
  openingSchedule?: Maybe<WeeklyOpeningSchedule>;
  originId: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
}

export interface InitiatePaymentBillingAddressInput {
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
}

export interface InitiatePaymentCustomerInput {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
}

export interface InitiatePaymentInput {
  billingAddress?: InputMaybe<InitiatePaymentBillingAddressInput>;
  customer: InitiatePaymentCustomerInput;
  transactionValue: MoneyInput;
}

export interface InitiatePaymentPayload {
  __typename?: 'InitiatePaymentPayload';
  libraryUrl: Scalars['URL'];
  paymentPageConfigurationId: Scalars['String'];
  sessionId: Scalars['String'];
  transactionId: Scalars['String'];
}

export interface InProgressCompanyAccountRegistrationInput {
  address?: InputMaybe<RegisterAddressInput>;
  numberOfEmployees?: InputMaybe<Scalars['Int']>;
  taxNumber?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<Scalars['String']>;
}

export interface InProgressContactRegistrationInput {
  academicTitle?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  function?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

export enum InvoiceOption {
  BLANK = 'BLANK',
  COST_CENTER = 'COST_CENTER',
  ORGANIZATIONAL_REFERENCE = 'ORGANIZATIONAL_REFERENCE',
  PURCHASE_ORDER_NUMBER = 'PURCHASE_ORDER_NUMBER',
  SHIP_TO = 'SHIP_TO'
}

export interface InvoiceStatus extends Localizable {
  __typename?: 'InvoiceStatus';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface InvoiceStatusNameArgs {
  localization: LocalizationInput;
}

export enum ItemCategoryGroup {
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export interface ItemPriceInformation {
  __typename?: 'ItemPriceInformation';
  priceQuantity?: Maybe<Scalars['Float']>;
  priceUnit?: Maybe<SalesUnit>;
  totalPrice?: Maybe<Money>;
  unitPrice?: Maybe<Money>;
}

export interface LicenseUserAssignment extends Node {
  __typename?: 'LicenseUserAssignment';
  email: Scalars['String'];
  id: Scalars['ID'];
  subscriptionStatus: SoftwareSubscriptionAssignmentStatus;
}

export interface Link {
  __typename?: 'Link';
  label?: Maybe<Scalars['String']>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  uri?: Maybe<Scalars['String']>;
}

export interface Localizable {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface LocalizableNameArgs {
  localization: LocalizationInput;
}

export interface LocalizationInput {
  country: Scalars['String'];
  language: Scalars['String'];
}

export interface LocalizedValueFilterInput {
  ids: Array<Scalars['String']>;
}

export interface MarketingBannerFilterInput {
  cartId?: InputMaybe<Scalars['ID']>;
  journeyId: Scalars['UUID'];
  /** CMS page template name, HomePage, etc */
  pageType?: InputMaybe<Scalars['String']>;
  permanentlyBannedBannerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productId?: InputMaybe<Scalars['String']>;
  /** Current page uri */
  uri: Scalars['String'];
}

export interface MaxDiscountDeterminationRule {
  __typename?: 'MaxDiscountDeterminationRule';
  checkoutPossible?: Maybe<Scalars['Boolean']>;
  entryLevelWarnings?: Maybe<Scalars['Boolean']>;
  headerPolicyExceeded?: Maybe<Scalars['Boolean']>;
  itemPolicyExceeded?: Maybe<Scalars['Boolean']>;
  warningLevel?: Maybe<Scalars['String']>;
}

export interface MigrateLegacySoftwareSubscriptionInput {
  subscriptionId: Scalars['ID'];
}

export interface MigrateLegacySoftwareSubscriptionPayload {
  __typename?: 'MigrateLegacySoftwareSubscriptionPayload';
  subscriptionId: Scalars['ID'];
}

export interface MiniTeaserBanner extends Node {
  __typename?: 'MiniTeaserBanner';
  body?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageAlt?: Maybe<Scalars['String']>;
  imageUri?: Maybe<Scalars['String']>;
  linkUri?: Maybe<Scalars['String']>;
  webAnalyticsData?: Maybe<WebAnalyticsData>;
}

export interface Money {
  __typename?: 'Money';
  amount?: Maybe<Scalars['BigDecimal']>;
  currency?: Maybe<Scalars['String']>;
}

export interface MoneyInput {
  amount: Scalars['BigDecimal'];
  currency: Scalars['String'];
}

export interface Mutation {
  __typename?: 'Mutation';
  acceptSoftwareSubscriptionMasterAgreementAmendment?: Maybe<AcceptSoftwareSubscriptionMasterAgreementAmendmentPayload>;
  activateCampaignEVoucher?: Maybe<ActivateCampaignEVoucherPayload>;
  activateSoftwareSubscription?: Maybe<ActivateSoftwareSubscriptionPayload>;
  addToCart?: Maybe<AddToCartPayload>;
  addToShoppingList?: Maybe<AddToShoppingListPayload>;
  applyOrderDraftEVoucher: ApplyOrderDraftEVoucherPayload;
  approveFleetQuotation?: Maybe<UpdateFleetQuotationPayload>;
  approveQuotationForRepairNotifications?: Maybe<RepairQuotationDecisionPayload>;
  assignSoftwareSubscriptionContact?: Maybe<AssignSoftwareSubscriptionContactPayload>;
  assignSoftwareSubscriptionContacts?: Maybe<AssignSoftwareSubscriptionContactsPayload>;
  calculateSoftwareSubscriptionPrice?: Maybe<CalculateSoftwareSubscriptionPricePayload>;
  callMeBack?: Maybe<CallMeBackPayload>;
  cancelPurchaseRequest: UpdatePurchaseRequestPayload;
  cancelSoftwareSubscription?: Maybe<CancelSoftwareSubscriptionPayload>;
  checkAddress?: Maybe<CheckAddressPayload>;
  copyCompanyToPrivateShoppingList?: Maybe<CopyCompanyToPrivateShoppingPayload>;
  copyPrivateToCompanyShoppingList?: Maybe<CopyPrivateToCompanyShoppingPayload>;
  createAccountEVoucher?: Maybe<CreateAccountEVoucherPayload>;
  createCampaignEVoucher?: Maybe<CreateCampaignEVoucherPayload>;
  /** This mutation is used for creating a new cart for anonymous user or try to restore existing cart for logged in user */
  createCart?: Maybe<CreateCartPayload>;
  createCompanyShoppingList?: Maybe<CreateShoppingListPayload>;
  createContact?: Maybe<CreateContactPayload>;
  createCustomerCareNote?: Maybe<CustomerCareNotePayload>;
  createFleetEContract?: Maybe<EContractPayload>;
  createLegacySoftwareSubscriptionMasterAgreement?: Maybe<CreateLegacySoftwareSubscriptionMasterAgreementPayload>;
  createPrivateShoppingList?: Maybe<CreateShoppingListPayload>;
  createShippingAddress?: Maybe<CreateShippingAddressPayload>;
  createSoftwareSubscriptionMasterAgreementAmendment?: Maybe<CreateSoftwareSubscriptionMasterAgreementAmendmentPayload>;
  deactivateEVoucher?: Maybe<DeactivateEVoucherPayload>;
  declineSoftwareSubscriptionMasterAgreementAmendment?: Maybe<DeclineSoftwareSubscriptionMasterAgreementAmendmentPayload>;
  deleteOrderDraftPurchaseOrderDocument?: Maybe<DeleteOrderDraftPurchaseOrderDocumentPayload>;
  deletePurchaseRequest: UpdatePurchaseRequestPayload;
  deleteShoppingList?: Maybe<DeleteShoppingListPayload>;
  deleteSoftwareSubscription?: Maybe<DeleteSoftwareSubscriptionPayload>;
  generateCircularityReport?: Maybe<GenerateCircularityReportPayload>;
  generateEContractIframeUrl?: Maybe<EContractPayload>;
  generateEVoucherCampaignReport?: Maybe<GenerateEVoucherCampaignReportPayload>;
  generateEVoucherListReport?: Maybe<GenerateEVoucherListReportPayload>;
  /** @deprecated Use generateEContractIframeUrl */
  generateFleetEContractIframeUrl?: Maybe<EContractPayload>;
  /** RapidPay specific as rework is likely soon */
  generateRapidPayAccessToken?: Maybe<GenerateRapidPayAccessTokenPayload>;
  generateSubscriptionActivationEContractIframeUrl?: Maybe<EContractPayload>;
  generateSubscriptionAmendmentEContractIframeUrl?: Maybe<EContractPayload>;
  initiatePayment?: Maybe<InitiatePaymentPayload>;
  markContactAsFleetExchangeResponsible?: Maybe<UpdateContactPayload>;
  markContactAsFleetResponsible?: Maybe<UpdateContactPayload>;
  markFleetQuotationForEContracting?: Maybe<UpdateFleetQuotationPayload>;
  migrateLegacySoftwareSubscription?: Maybe<MigrateLegacySoftwareSubscriptionPayload>;
  orderBatteriesExchange?: Maybe<OrderBatteriesExchangePayload>;
  quickAddToCart?: Maybe<AddToCartPayload>;
  reactivateEVoucher?: Maybe<ReactivateEVoucherPayload>;
  reassignSoftwareSubscriptionContact?: Maybe<ReassignSoftwareSubscriptionContactPayload>;
  recycleBatteries?: Maybe<RecycleBatteriesDecisionPayload>;
  recycleToolsForRepairNotifications?: Maybe<RepairQuotationDecisionPayload>;
  registerCustomer?: Maybe<RegisterCustomerPayload>;
  rejectFleetQuotation?: Maybe<UpdateFleetQuotationPayload>;
  rejectPurchaseRequest: UpdatePurchaseRequestPayload;
  releaseOrderDraftEVoucher: ReleaseOrderDraftEVoucherPayload;
  removeAllAccountsFromCampaignEVoucher?: Maybe<RemoveAllAccountsFromCampaignEVoucherPayload>;
  removeAllSoftwareSubscriptionScheduledAmendments?: Maybe<RemoveAllSoftwareSubscriptionScheduledAmendmentsPayload>;
  removeItemsFromShoppingList?: Maybe<RemoveItemsFromShoppingListPayload>;
  reprintOrderDeliveryNotes?: Maybe<ReprintOrderDeliveryNotesPayload>;
  resendFleetQuotationConfirmation?: Maybe<ResendFleetQuotationConfirmationPayload>;
  resendOrderConfirmation?: Maybe<ResendOrderConfirmationPayload>;
  /** @deprecated Use reprintOrderDeliveryNotes */
  resendOrderDeliveryNotes?: Maybe<ResendOrderDeliveryNotesPayload>;
  resendQuotationConfirmation?: Maybe<ResendQuotationConfirmationPayload>;
  returnTools?: Maybe<ToolsProcessPayload>;
  /** Saves a customer journey by appending the URL to an existing journey or creates a new one in case journeyId is not provided/it expired. */
  saveCustomerJourney?: Maybe<SaveCustomerJourneyPayload>;
  /** @deprecated Saving of registration information will not be supported. */
  saveInProgressCustomerRegistration?: Maybe<SaveInProgressCustomerRegistrationPayload>;
  /** @deprecated Saving of registration information will not be supported. */
  saveRegistrationContact?: Maybe<RegistrationContactPayload>;
  sendMessageToCustomerService?: Maybe<SendMessageToCustomerServicePayload>;
  signFleetQuotation?: Maybe<UpdateFleetQuotationPayload>;
  submitGuestOrder?: Maybe<SubmitGuestOrderPayload>;
  submitOrder?: Maybe<SubmitOrderPayload>;
  temporarilyBanBanner?: Maybe<TemporarilyBanBannerPayload>;
  tradeInAndRecycleToolsForRepairNotifications?: Maybe<RepairQuotationDecisionPayload>;
  transferSoftwareSubscriptionAdminRights?: Maybe<TransferSoftwareSubscriptionAdminRightsPayload>;
  unassignSoftwareSubscriptionContact?: Maybe<UnassignSoftwareSubscriptionContactPayload>;
  updateCampaignEVoucher?: Maybe<UpdateCampaignEVoucherPayload>;
  updateFleetEContract?: Maybe<EContractPayload>;
  updateFleetQuotation?: Maybe<UpdateFleetQuotationPayload>;
  updateOrderDraftBillToAccount?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftDeliveryMethod?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftEntryPaymentMethod?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftPurchaseOrderNumber?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftShipToAccount?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftShipToContact?: Maybe<UpdateOrderDraftPayload>;
  updateOrderDraftShipToHiltiCenter?: Maybe<UpdateOrderDraftPayload>;
  updateShoppingList?: Maybe<UpdateShoppingListPayload>;
  updateSoftwareSubscriptionPurchaseOrderNumber?: Maybe<UpdateSoftwareSubscriptionPurchaseOrderNumberPayload>;
  /** RapidPay specific as rework is likely soon */
  updateSoftwareSubscriptionRapidPayCreditCardDetails?: Maybe<UpdateSoftwareSubscriptionRapidPayCreditCardDetailsPayload>;
  validatePurchaseOrderNumber?: Maybe<ValidatePurchaseOrderNumberPayload>;
  /** RapidPay specific as rework is likely soon */
  verifyRapidPayCreditCardAuthentication?: Maybe<VerifyRapidPayCreditCardAuthenticationPayload>;
}

export interface MutationAcceptSoftwareSubscriptionMasterAgreementAmendmentArgs {
  input: AcceptSoftwareSubscriptionMasterAgreementAmendmentInput;
}

export interface MutationActivateCampaignEVoucherArgs {
  id: Scalars['ID'];
}

export interface MutationActivateSoftwareSubscriptionArgs {
  input: ActivateSoftwareSubscriptionInput;
}

export interface MutationAddToCartArgs {
  input: AddToCartInput;
}

export interface MutationAddToShoppingListArgs {
  input: AddToShoppingListInput;
}

export interface MutationApplyOrderDraftEVoucherArgs {
  input: ApplyOrderDraftEVoucherInput;
}

export interface MutationApproveFleetQuotationArgs {
  input: ApproveFleetQuotationInput;
}

export interface MutationApproveQuotationForRepairNotificationsArgs {
  input: ApproveQuotationForRepairNotifications;
}

export interface MutationAssignSoftwareSubscriptionContactArgs {
  input: AssignSoftwareSubscriptionContactInput;
}

export interface MutationAssignSoftwareSubscriptionContactsArgs {
  input: AssignSoftwareSubscriptionContactsInput;
}

export interface MutationCalculateSoftwareSubscriptionPriceArgs {
  input: CalculateSoftwareSubscriptionPriceInput;
}

export interface MutationCallMeBackArgs {
  input: CallMeBackInput;
}

export interface MutationCancelPurchaseRequestArgs {
  id: Scalars['ID'];
}

export interface MutationCancelSoftwareSubscriptionArgs {
  input: CancelSoftwareSubscriptionInput;
}

export interface MutationCheckAddressArgs {
  input: CheckAddressInput;
}

export interface MutationCopyCompanyToPrivateShoppingListArgs {
  input: CopyCompanyToPrivateShoppingListInput;
}

export interface MutationCopyPrivateToCompanyShoppingListArgs {
  input: CopyPrivateToCompanyShoppingListInput;
}

export interface MutationCreateAccountEVoucherArgs {
  input: CreateAccountEVoucherInput;
}

export interface MutationCreateCampaignEVoucherArgs {
  input: CreateCampaignEVoucherInput;
}

export interface MutationCreateCartArgs {
  input: CreateCartInput;
}

export interface MutationCreateCompanyShoppingListArgs {
  input: CreateCompanyShoppingListInput;
}

export interface MutationCreateContactArgs {
  input: CreateContactInput;
}

export interface MutationCreateCustomerCareNoteArgs {
  input: CreateCustomerCareNoteInput;
}

export interface MutationCreateFleetEContractArgs {
  input: CreateEContractInput;
}

export interface MutationCreateLegacySoftwareSubscriptionMasterAgreementArgs {
  input: CreateLegacySoftwareSubscriptionMasterAgreementInput;
}

export interface MutationCreatePrivateShoppingListArgs {
  input: CreatePrivateShoppingListInput;
}

export interface MutationCreateShippingAddressArgs {
  input: CreateShippingAddressInput;
}

export interface MutationCreateSoftwareSubscriptionMasterAgreementAmendmentArgs {
  input: CreateSoftwareSubscriptionMasterAgreementAmendmentInput;
}

export interface MutationDeactivateEVoucherArgs {
  id: Scalars['ID'];
}

export interface MutationDeclineSoftwareSubscriptionMasterAgreementAmendmentArgs {
  input: DeclineSoftwareSubscriptionMasterAgreementAmendmentInput;
}

export interface MutationDeleteOrderDraftPurchaseOrderDocumentArgs {
  input: DeleteOrderDraftPurchaseOrderDocumentInput;
}

export interface MutationDeletePurchaseRequestArgs {
  id: Scalars['ID'];
}

export interface MutationDeleteShoppingListArgs {
  id: Scalars['ID'];
}

export interface MutationDeleteSoftwareSubscriptionArgs {
  input: DeleteSoftwareSubscriptionInput;
}

export interface MutationGenerateCircularityReportArgs {
  input: GenerateCircularityReportInput;
}

export interface MutationGenerateEContractIframeUrlArgs {
  input: EContractIframeUrlInput;
}

export interface MutationGenerateEVoucherCampaignReportArgs {
  id: Scalars['ID'];
}

export interface MutationGenerateEVoucherListReportArgs {
  input: GenerateEVoucherListReportInput;
}

export interface MutationGenerateFleetEContractIframeUrlArgs {
  input: EContractIframeUrlInput;
}

export interface MutationGenerateRapidPayAccessTokenArgs {
  localization?: InputMaybe<LocalizationInput>;
}

export interface MutationGenerateSubscriptionActivationEContractIframeUrlArgs {
  input: SubscriptionActivationEContractIframeUrlInput;
}

export interface MutationGenerateSubscriptionAmendmentEContractIframeUrlArgs {
  input: GenerateSubscriptionAmendmentEContractIframeUrlInput;
}

export interface MutationInitiatePaymentArgs {
  input: InitiatePaymentInput;
}

export interface MutationMarkContactAsFleetExchangeResponsibleArgs {
  id: Scalars['ID'];
}

export interface MutationMarkContactAsFleetResponsibleArgs {
  id: Scalars['ID'];
}

export interface MutationMarkFleetQuotationForEContractingArgs {
  quotationId: Scalars['ID'];
}

export interface MutationMigrateLegacySoftwareSubscriptionArgs {
  input: MigrateLegacySoftwareSubscriptionInput;
}

export interface MutationOrderBatteriesExchangeArgs {
  input: OrderBatteriesExchangeInput;
}

export interface MutationQuickAddToCartArgs {
  input: QuickAddToCartInput;
}

export interface MutationReactivateEVoucherArgs {
  input: ReactivateEVoucherInput;
}

export interface MutationReassignSoftwareSubscriptionContactArgs {
  input: ReassignSoftwareSubscriptionContactInput;
}

export interface MutationRecycleBatteriesArgs {
  input: RecycleBatteriesInput;
}

export interface MutationRecycleToolsForRepairNotificationsArgs {
  input: RecycleToolsForRepairNotificationsInput;
}

export interface MutationRegisterCustomerArgs {
  input: RegisterCustomerInput;
}

export interface MutationRejectFleetQuotationArgs {
  input: RejectFleetQuotationInput;
}

export interface MutationRejectPurchaseRequestArgs {
  input: RejectPurchaseRequestInput;
}

export interface MutationReleaseOrderDraftEVoucherArgs {
  input: ReleaseOrderDraftEVoucherInput;
}

export interface MutationRemoveAllAccountsFromCampaignEVoucherArgs {
  id: Scalars['ID'];
}

export interface MutationRemoveAllSoftwareSubscriptionScheduledAmendmentsArgs {
  input: RemoveAllSoftwareSubscriptionScheduledAmendmentsInput;
}

export interface MutationRemoveItemsFromShoppingListArgs {
  input: RemoveItemsFromShoppingListInput;
}

export interface MutationReprintOrderDeliveryNotesArgs {
  input: ReprintOrderDeliveryNotesInput;
}

export interface MutationResendFleetQuotationConfirmationArgs {
  input: ResendFleetQuotationConfirmationInput;
}

export interface MutationResendOrderConfirmationArgs {
  input: ResendOrderConfirmationInput;
}

export interface MutationResendOrderDeliveryNotesArgs {
  input: ResendOrderDeliveryNotesInput;
}

export interface MutationResendQuotationConfirmationArgs {
  input: ResendQuotationConfirmationInput;
}

export interface MutationReturnToolsArgs {
  input: ReturnToolsInput;
}

export interface MutationSaveCustomerJourneyArgs {
  input: SaveCustomerJourneyInput;
}

export interface MutationSaveInProgressCustomerRegistrationArgs {
  input: SaveInProgressCustomerRegistrationInput;
}

export interface MutationSaveRegistrationContactArgs {
  input: RegistrationContactInput;
}

export interface MutationSendMessageToCustomerServiceArgs {
  input: SendMessageToCustomerServiceInput;
}

export interface MutationSignFleetQuotationArgs {
  input: SignFleetQuotationInput;
}

export interface MutationSubmitGuestOrderArgs {
  input: SubmitGuestOrderInput;
}

export interface MutationSubmitOrderArgs {
  input: SubmitOrderInput;
}

export interface MutationTemporarilyBanBannerArgs {
  input: TemporarilyBanBannerInput;
  localization: LocalizationInput;
}

export interface MutationTradeInAndRecycleToolsForRepairNotificationsArgs {
  input: TradeInAndRecycleToolsForRepairNotificationsInput;
}

export interface MutationTransferSoftwareSubscriptionAdminRightsArgs {
  input: TransferSoftwareSubscriptionAdminRightsInput;
}

export interface MutationUnassignSoftwareSubscriptionContactArgs {
  input: UnassignSoftwareSubscriptionContactInput;
}

export interface MutationUpdateCampaignEVoucherArgs {
  input: UpdateCampaignEVoucherInput;
}

export interface MutationUpdateFleetEContractArgs {
  input: UpdateEContractInput;
}

export interface MutationUpdateFleetQuotationArgs {
  input: UpdateFleetQuotationInput;
}

export interface MutationUpdateOrderDraftBillToAccountArgs {
  input: UpdateOrderDraftBillToAccountInput;
}

export interface MutationUpdateOrderDraftDeliveryMethodArgs {
  input: UpdateOrderDraftDeliveryMethodInput;
}

export interface MutationUpdateOrderDraftEntryPaymentMethodArgs {
  input: UpdateOrderDraftEntryPaymentMethodInput;
}

export interface MutationUpdateOrderDraftPurchaseOrderNumberArgs {
  input: UpdateOrderDraftPurchaseOrderNumberInput;
}

export interface MutationUpdateOrderDraftShipToAccountArgs {
  input: UpdateOrderDraftShipToAccountInput;
}

export interface MutationUpdateOrderDraftShipToContactArgs {
  input: UpdateOrderDraftShipToContactInput;
}

export interface MutationUpdateOrderDraftShipToHiltiCenterArgs {
  input: UpdateOrderDraftShipToHiltiCenterInput;
}

export interface MutationUpdateShoppingListArgs {
  input: UpdateShoppingListInput;
}

export interface MutationUpdateSoftwareSubscriptionPurchaseOrderNumberArgs {
  input: UpdateSoftwareSubscriptionPurchaseOrderNumberInput;
}

export interface MutationUpdateSoftwareSubscriptionRapidPayCreditCardDetailsArgs {
  input: UpdateSoftwareSubscriptionRapidPayCreditCardDetailsInput;
}

export interface MutationValidatePurchaseOrderNumberArgs {
  input: ValidatePurchaseOrderNumberInput;
}

export interface MutationVerifyRapidPayCreditCardAuthenticationArgs {
  input: VerifyRapidPayCreditCardAuthenticationInput;
  localization?: InputMaybe<LocalizationInput>;
}

/** An object with a Globally Unique ID */
export interface Node {
  id: Scalars['ID'];
}

export interface NonTargetedCampaignEVoucherDetails {
  __typename?: 'NonTargetedCampaignEVoucherDetails';
  eligibleMarketingConsents?: Maybe<EVoucherMarketingConsents>;
  maxNumberOfEmployees?: Maybe<Scalars['Int']>;
  minNumberOfEmployees?: Maybe<Scalars['Int']>;
  registeredAfter?: Maybe<Scalars['Date']>;
  registeredBefore?: Maybe<Scalars['Date']>;
}

export interface NonTargetedRedemptionRulesInput {
  areEventsAndPromotionsRequired?: InputMaybe<Scalars['Boolean']>;
  isCustomerFeedbackRequired?: InputMaybe<Scalars['Boolean']>;
  isNewsletterRequired?: InputMaybe<Scalars['Boolean']>;
  isPhoneRequired?: InputMaybe<Scalars['Boolean']>;
  isSocialNetworkRequired?: InputMaybe<Scalars['Boolean']>;
  isTechnicalEducationRequired?: InputMaybe<Scalars['Boolean']>;
  maxNumberOfEmployees?: InputMaybe<Scalars['Int']>;
  minNumberOfEmployees?: InputMaybe<Scalars['Int']>;
  registeredAfter?: InputMaybe<Scalars['Date']>;
  registeredBefore?: InputMaybe<Scalars['Date']>;
}

export interface Order extends GenericOrder, Node, Pageable {
  __typename?: 'Order';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  clickAndCollectHiltiCenter?: Maybe<HiltiCenter>;
  /** Additional reference number. For example littra number for MO SE */
  customerAdditionalReferenceNumber?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<GenericOrderEntry>;
  eVoucherValue?: Maybe<Money>;
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  id: Scalars['ID'];
  ipiTax?: Maybe<Money>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  /** This field is not mapped */
  payerAccount?: Maybe<Account>;
  paymentMethod?: Maybe<PaymentMethod>;
  preparationStatus?: Maybe<CompletionStatus>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  rejectionStatus?: Maybe<OrderRejectionStatus>;
  repairNotification?: Maybe<RepairNotification>;
  /** @deprecated Use repairNotification.id */
  repairOrderNotificationId?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<SalesChannel>;
  shipments?: Maybe<Array<ShipmentInformation>>;
  shipmentStatus?: Maybe<CompletionStatus>;
  shippingCharges?: Maybe<Money>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  /** This field is not mapped */
  soldTo?: Maybe<Customer>;
  status?: Maybe<OrderStatus>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
  type?: Maybe<OrderType>;
}

export interface OrderBatteriesExchangeInput {
  billToAccountOriginId: Scalars['String'];
  carrierInstructions?: InputMaybe<Scalars['String']>;
  lock?: InputMaybe<BatteriesExchangeLockType>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  shipToAccountOriginId: Scalars['String'];
  shipToContactOriginId: Scalars['String'];
  toolIds: Array<InputMaybe<Scalars['String']>>;
}

export interface OrderBatteriesExchangePayload {
  __typename?: 'OrderBatteriesExchangePayload';
  toolIds?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface OrderDetails extends GenericOrder, Node, Pageable {
  __typename?: 'OrderDetails';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  clickAndCollectHiltiCenter?: Maybe<HiltiCenter>;
  /** Additional reference number. For example littra number for MO SE */
  customerAdditionalReferenceNumber?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<GenericOrderEntry>;
  eVoucherValue?: Maybe<Money>;
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  id: Scalars['ID'];
  ipiTax?: Maybe<Money>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  /** This field is not mapped */
  payerAccount?: Maybe<Account>;
  paymentMethod?: Maybe<PaymentMethod>;
  preparationStatus?: Maybe<CompletionStatus>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  rejectionStatus?: Maybe<OrderRejectionStatus>;
  repairNotification?: Maybe<RepairNotification>;
  /** @deprecated Use repairNotification.id */
  repairOrderNotificationId?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<SalesChannel>;
  shipments?: Maybe<Array<ShipmentInformation>>;
  shipmentStatus?: Maybe<CompletionStatus>;
  shippingCharges?: Maybe<Money>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  /** This field is not mapped */
  soldTo?: Maybe<Customer>;
  status?: Maybe<OrderStatus>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
  type?: Maybe<OrderType>;
}

export interface OrderDraft extends Node {
  __typename?: 'OrderDraft';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  carrierInstructions?: Maybe<Scalars['String']>;
  deliveryType?: Maybe<DeliveryType>;
  eVoucherCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  purchaseOrderDocument?: Maybe<PurchaseOrderDocument>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  simulationStatus?: Maybe<OrderDraftSimulationStatus>;
  standardDetails?: Maybe<OrderDraftStandardDetails>;
  totalWeight?: Maybe<Dimension>;
}

export interface OrderDraftEntryExpectedShipment {
  __typename?: 'OrderDraftEntryExpectedShipment';
  quantity: Scalars['Float'];
  shipmentScheduleInformation: ShipmentScheduleInformation;
}

export enum OrderDraftEntryType {
  FLEET = 'FLEET',
  PEAK = 'PEAK',
  SOFTWARE = 'SOFTWARE',
  STANDARD = 'STANDARD',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export enum OrderDraftSimulationStatus {
  CALCULATED = 'CALCULATED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_SIMULATED = 'NOT_SIMULATED',
  SIMULATED = 'SIMULATED',
  SKIPPED = 'SKIPPED'
}

export interface OrderDraftStandardDetails {
  __typename?: 'OrderDraftStandardDetails';
  deliveryMethod?: Maybe<DeliveryMethod>;
  entries: Array<OrderDraftStandardEntry>;
  paymentMethod?: Maybe<PaymentMethod>;
  priceInformation?: Maybe<PriceInformation>;
  requestedDeliveryDate?: Maybe<Scalars['Date']>;
}

export interface OrderDraftStandardEntry {
  __typename?: 'OrderDraftStandardEntry';
  expectedShipments?: Maybe<Array<OrderDraftEntryExpectedShipment>>;
  item: Product;
  priceInformation: EntryPriceInformation;
  quantity?: Maybe<Scalars['Float']>;
}

export interface OrderDraftStandardEntryItemArgs {
  localization: LocalizationInput;
}

export interface OrderEntry extends GenericOrderEntry {
  __typename?: 'OrderEntry';
  comboChildren?: Maybe<Array<GenericOrderEntry>>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  discount?: Maybe<Discount>;
  entryNumber: Scalars['Int'];
  expectedShipments?: Maybe<Array<Maybe<ShipmentScheduleInformation>>>;
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  invoiceStatus?: Maybe<InvoiceStatus>;
  ipiTax?: Maybe<Money>;
  item?: Maybe<Product>;
  itemDescription?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Money>;
  priceUnit?: Maybe<SalesUnit>;
  quantity?: Maybe<Scalars['Float']>;
  rejectionStatus?: Maybe<OrderEntryRejectionStatus>;
  salesUnit?: Maybe<SalesUnit>;
  shippedQuantity?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Money>;
  unitPrice?: Maybe<Money>;
  usagePeriod?: Maybe<Scalars['Int']>;
}

export interface OrderEntryItemArgs {
  localization: LocalizationInput;
}

export interface OrderEntryRejectionStatus extends Localizable {
  __typename?: 'OrderEntryRejectionStatus';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface OrderEntryRejectionStatusNameArgs {
  localization: LocalizationInput;
}

export interface OrderPaginationResult extends PaginationResult {
  __typename?: 'OrderPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<Order>>;
}

export interface OrderRejectionStatus extends Localizable {
  __typename?: 'OrderRejectionStatus';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface OrderRejectionStatusNameArgs {
  localization: LocalizationInput;
}

export interface OrdersFilterInput {
  buyerContactId?: InputMaybe<Scalars['String']>;
  deliveryStatus?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  shipToAccountId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subtypes?: InputMaybe<Array<Scalars['String']>>;
  toDate?: InputMaybe<Scalars['Date']>;
  types?: InputMaybe<Array<Scalars['String']>>;
}

export interface OrderStatus extends Localizable {
  __typename?: 'OrderStatus';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface OrderStatusNameArgs {
  localization: LocalizationInput;
}

export interface OrderType extends Localizable {
  __typename?: 'OrderType';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface OrderTypeNameArgs {
  localization: LocalizationInput;
}

export interface Pageable {
  id: Scalars['ID'];
}

export interface PageInfo {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
}

export interface PageInput {
  /** Cursor that indicates specific place on the list */
  after?: InputMaybe<Scalars['String']>;
  /** Cursor that indicates specific place on the list */
  before?: InputMaybe<Scalars['String']>;
  /** Amount of results to be returned after provided cursor */
  first?: InputMaybe<Scalars['Int']>;
  /** Amount of results to be returned before provided cursor */
  last?: InputMaybe<Scalars['Int']>;
}

export interface PaginationDetails {
  __typename?: 'PaginationDetails';
  /** The current page number */
  currentPage: Scalars['Int'];
  /** Determines if there are more results in the data store */
  hasMorePages?: Maybe<Scalars['Boolean']>;
  /** The page number of the last available page */
  lastPage?: Maybe<Scalars['Int']>;
  /** The number of results to be shown per page */
  pageSize: Scalars['Int'];
  /** The total number of matching results in the data store */
  totalResults?: Maybe<Scalars['Int']>;
}

export interface PaginationInput {
  /** The desired results page number */
  page?: InputMaybe<Scalars['Int']>;
  /** The desired number of results per page */
  pageSize?: InputMaybe<Scalars['Int']>;
}

export interface PaginationResult {
  /** The details needed to display and support pagination */
  paginationDetails: PaginationDetails;
  /** The results for the pagination query */
  results: Array<Maybe<Pageable>>;
}

export interface PaymentMethod extends Localizable {
  __typename?: 'PaymentMethod';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface PaymentMethodNameArgs {
  localization: LocalizationInput;
}

export interface PaymentTerms extends Localizable {
  __typename?: 'PaymentTerms';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface PaymentTermsNameArgs {
  localization: LocalizationInput;
}

export interface PeakPrice {
  __typename?: 'PeakPrice';
  dailyFee?: Maybe<Money>;
  isBelowMinimumRentalPeriod?: Maybe<Scalars['Boolean']>;
  priceTiers?: Maybe<Array<PriceTier>>;
  rentalPeriod?: Maybe<Scalars['Int']>;
  totalCost?: Maybe<Money>;
}

export interface PeakPriceFilterInput {
  currency: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  rentalEndDate?: InputMaybe<Scalars['Date']>;
  rentalStartDate?: InputMaybe<Scalars['Date']>;
}

export interface PeakToolOption {
  __typename?: 'PeakToolOption';
  hasSameLogisticToolType?: Maybe<Scalars['Boolean']>;
  hasSamePricingToolType?: Maybe<Scalars['Boolean']>;
  logisticProduct?: Maybe<Product>;
  product?: Maybe<Product>;
}

export enum Permission {
  BROWSE_ALL_CAMPAIGN_EVOUCHER = 'BROWSE_ALL_CAMPAIGN_EVOUCHER',
  BROWSE_ALL_CONSUMABLE_EVOUCHER = 'BROWSE_ALL_CONSUMABLE_EVOUCHER',
  BROWSE_CREATED_BY_CONSUMABLE_EVOUCHER = 'BROWSE_CREATED_BY_CONSUMABLE_EVOUCHER',
  BROWSE_CURRENT_CUSTOMER_EVOUCHER = 'BROWSE_CURRENT_CUSTOMER_EVOUCHER',
  BROWSE_EVOUCHER_CONFIG = 'BROWSE_EVOUCHER_CONFIG',
  CREATE_CAMPAIGN_EVOUCHER = 'CREATE_CAMPAIGN_EVOUCHER',
  CREATE_CONSUMABLE_EVOUCHER = 'CREATE_CONSUMABLE_EVOUCHER',
  DEACTIVATE_EVOUCHER = 'DEACTIVATE_EVOUCHER',
  DELETE_EVOUCHER = 'DELETE_EVOUCHER',
  REACTIVATE_EVOUCHER = 'REACTIVATE_EVOUCHER',
  REPORT_CAMPAIGN_EVOUCHER = 'REPORT_CAMPAIGN_EVOUCHER',
  REPORT_CONSUMABLE_EVOUCHER = 'REPORT_CONSUMABLE_EVOUCHER',
  REPORT_CREATED_BY_CONSUMABLE_EVOUCHER = 'REPORT_CREATED_BY_CONSUMABLE_EVOUCHER',
  UPDATE_EVOUCHER_CONFIG = 'UPDATE_EVOUCHER_CONFIG'
}

export interface Price {
  __typename?: 'Price';
  currency: Scalars['String'];
  fleetDetails?: Maybe<FleetPriceDetails>;
  productId: Scalars['String'];
  quantity: Scalars['Float'];
  standardDetails?: Maybe<StandardPriceDetails>;
  subscriptionDetails?: Maybe<SubscriptionPriceDetails>;
}

export interface PriceInformation {
  __typename?: 'PriceInformation';
  discount?: Maybe<Money>;
  shippingCharges?: Maybe<Money>;
  subTotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  total?: Maybe<Money>;
  totalBeforeTax?: Maybe<Money>;
}

export interface PricesFilterInput {
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  products: Array<ProductPriceInput>;
  types: Array<PriceType>;
}

export interface PriceTier {
  __typename?: 'PriceTier';
  dailyFee?: Maybe<Money>;
  rentalFromDay?: Maybe<Scalars['Int']>;
  rentalToDay?: Maybe<Scalars['Int']>;
}

export enum PriceType {
  FLEET = 'FLEET',
  STANDARD = 'STANDARD',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export interface Product extends Node {
  __typename?: 'Product';
  categoryGroup?: Maybe<ItemCategoryGroup>;
  /** This field should not be used directly, it was added for the product compound key in order to resolve reference */
  country: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  incrementalOrderQuantity?: Maybe<Scalars['Int']>;
  isPurchasable?: Maybe<Scalars['Boolean']>;
  /** This field should not be used directly, it was added for the product compound key in order to resolve reference */
  language: Scalars['String'];
  minOrderQuantity?: Maybe<Scalars['Int']>;
  packageContents?: Maybe<Array<Scalars['String']>>;
  packagingUnit?: Maybe<Scalars['String']>;
  rangeId?: Maybe<Scalars['String']>;
  salesUnitOfMeasure?: Maybe<UnitOfMeasure>;
  softwareAttributes?: Maybe<SoftwareAttributes>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ProductType>;
  weight?: Maybe<Dimension>;
}

export interface ProductThumbnailArgs {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface ProductBannerFilterInput {
  cartId?: InputMaybe<Scalars['ID']>;
  journeyId: Scalars['UUID'];
  /** CMS page template name, HomePage, etc */
  pageType?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  /** Current page uri */
  uri: Scalars['String'];
}

export interface ProductConfiguration {
  __typename?: 'ProductConfiguration';
  filters?: Maybe<Array<ProductConfigurationFilter>>;
  products?: Maybe<Array<Product>>;
}

export interface ProductConfigurationFilter {
  __typename?: 'ProductConfigurationFilter';
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<ProductConfigurationFilterType>;
  values?: Maybe<Array<ProductConfigurationFilterValue>>;
}

export enum ProductConfigurationFilterType {
  RADIO = 'RADIO',
  SELECT = 'SELECT'
}

export interface ProductConfigurationFilterValue {
  __typename?: 'ProductConfigurationFilterValue';
  applicableFilterValues?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  matchingProductIds?: Maybe<Array<Scalars['String']>>;
  value: Scalars['String'];
}

export interface ProductFeatureValue extends Node {
  __typename?: 'ProductFeatureValue';
  id: Scalars['ID'];
  value?: Maybe<Scalars['String']>;
}

export interface ProductPriceInput {
  productId: Scalars['String'];
  quantity: Scalars['Float'];
}

export interface ProductSearch {
  __typename?: 'ProductSearch';
  id: Scalars['ID'];
  isNew?: Maybe<Scalars['Boolean']>;
  isNuron?: Maybe<Scalars['Boolean']>;
  isSpecial?: Maybe<Scalars['Boolean']>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export enum ProductType {
  ACCESSORY = 'ACCESSORY',
  BATTERIES_AND_CHARGERS = 'BATTERIES_AND_CHARGERS',
  CONSUMABLE = 'CONSUMABLE',
  INSERT = 'INSERT',
  SERVICE = 'SERVICE',
  SOFTWARE = 'SOFTWARE',
  TOOL = 'TOOL'
}

export interface PurchaseOrderDocument {
  __typename?: 'PurchaseOrderDocument';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
}

export interface PurchaseRequest extends Node, Pageable {
  __typename?: 'PurchaseRequest';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  creationDate?: Maybe<Scalars['DateTime']>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  fleetDetails?: Maybe<PurchaseRequestFleetDetails>;
  id: Scalars['ID'];
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  purchaseTypes?: Maybe<Array<Maybe<PurchaseType>>>;
  rejectionComment?: Maybe<Scalars['String']>;
  rejectionReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  requester?: Maybe<Contact>;
  requesterComment?: Maybe<Scalars['String']>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  softwareProfisEngineeringDetails?: Maybe<PurchaseRequestProfisEngineeringDetails>;
  standardDetails?: Maybe<PurchaseRequestStandardDetails>;
  status?: Maybe<PurchaseRequestStatus>;
  subscriptionMonthlyDetails?: Maybe<PurchaseRequestSubscriptionMonthlyDetails>;
  subscriptionYearlyDetails?: Maybe<PurchaseRequestSubscriptionYearlyDetails>;
  /** This is technical field, not shown in UI. The purpose of it is to distinguish any changes done by other users (approver) */
  updatedByContactOriginId?: Maybe<Scalars['String']>;
}

export interface PurchaseRequestFleetDetails {
  __typename?: 'PurchaseRequestFleetDetails';
  items: Array<PurchaseRequestFleetEntry>;
  monthlyPriceInformation?: Maybe<PriceInformation>;
  upfrontPriceInformation?: Maybe<PriceInformation>;
}

export interface PurchaseRequestFleetEntry {
  __typename?: 'PurchaseRequestFleetEntry';
  fleetDetails?: Maybe<FleetDetails>;
  item?: Maybe<Product>;
  monthlyPriceInformation?: Maybe<ItemPriceInformation>;
  quantity: Scalars['Float'];
  salesUnit?: Maybe<SalesUnit>;
  upfrontPriceInformation?: Maybe<ItemPriceInformation>;
}

export interface PurchaseRequestFleetEntryItemArgs {
  localization: LocalizationInput;
}

export interface PurchaseRequestPaginationResult extends PaginationResult {
  __typename?: 'PurchaseRequestPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<PurchaseRequest>>;
}

export interface PurchaseRequestProfisEngineeringDetails {
  __typename?: 'PurchaseRequestProfisEngineeringDetails';
  items: Array<PurchaseRequestSoftwareProfisEngineeringEntry>;
  priceInformation: PriceInformation;
}

export interface PurchaseRequestsFilterInput {
  contactIds?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<PurchaseRequestStatus>>;
}

export interface PurchaseRequestSoftwareProfisEngineeringEntry {
  __typename?: 'PurchaseRequestSoftwareProfisEngineeringEntry';
  item?: Maybe<Product>;
  itemPriceInformation: ItemPriceInformation;
  quantity: Scalars['Float'];
  salesUnit?: Maybe<SalesUnit>;
}

export interface PurchaseRequestSoftwareProfisEngineeringEntryItemArgs {
  localization: LocalizationInput;
}

export interface PurchaseRequestStandardDetails {
  __typename?: 'PurchaseRequestStandardDetails';
  items: Array<PurchaseRequestStandardEntry>;
  priceInformation: PriceInformation;
}

export interface PurchaseRequestStandardEntry {
  __typename?: 'PurchaseRequestStandardEntry';
  item?: Maybe<Product>;
  itemPriceInformation: ItemPriceInformation;
  quantity: Scalars['Float'];
  salesUnit?: Maybe<SalesUnit>;
}

export interface PurchaseRequestStandardEntryItemArgs {
  localization: LocalizationInput;
}

export enum PurchaseRequestStatus {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REJECTED = 'REJECTED'
}

export interface PurchaseRequestSubscriptionEntry {
  __typename?: 'PurchaseRequestSubscriptionEntry';
  item?: Maybe<Product>;
  itemPriceInformation: ItemPriceInformation;
  quantity: Scalars['Float'];
  salesUnit?: Maybe<SalesUnit>;
}

export interface PurchaseRequestSubscriptionEntryItemArgs {
  localization: LocalizationInput;
}

export interface PurchaseRequestSubscriptionMonthlyDetails {
  __typename?: 'PurchaseRequestSubscriptionMonthlyDetails';
  items: Array<PurchaseRequestSubscriptionEntry>;
  priceInformation: PriceInformation;
}

export interface PurchaseRequestSubscriptionYearlyDetails {
  __typename?: 'PurchaseRequestSubscriptionYearlyDetails';
  items: Array<PurchaseRequestSubscriptionEntry>;
  priceInformation: PriceInformation;
}

export enum PurchaseType {
  FLEET = 'FLEET',
  SOFTWARE_PE = 'SOFTWARE_PE',
  STANDARD = 'STANDARD',
  SUBSCRIPTION_MONTHLY = 'SUBSCRIPTION_MONTHLY',
  SUBSCRIPTION_YEARLY = 'SUBSCRIPTION_YEARLY'
}

export interface Query {
  __typename?: 'Query';
  addressSuggestion?: Maybe<Address>;
  availabilityStores?: Maybe<StoreSearchResults>;
  batterySelfRecyclingDocument?: Maybe<BatterySelfRecyclingDocument>;
  billingAddresses?: Maybe<AccountConnection>;
  categoriesByIds: Array<Category>;
  category: Category;
  checkFleetQuotationForAccountEVoucher?: Maybe<AccountEVoucherFleetQuotationInformation>;
  checkStandardQuotationForAccountEVoucher?: Maybe<AccountEVoucherStandardQuotationInformation>;
  circularityReports: CircularityReportsPaginationResult;
  contactByOriginId?: Maybe<Contact>;
  contacts?: Maybe<ContactConnection>;
  contactsAssignableToSubscription?: Maybe<ContactsAssignableToSubscriptionPayload>;
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  customerCareNote?: Maybe<CustomerCareNote>;
  customerCareNotes?: Maybe<CustomerCareNotePaginationResult>;
  customerEVoucherRestrictions?: Maybe<CustomerEVoucherRestrictions>;
  customerPrices?: Maybe<Array<Price>>;
  eContractingFleetExchangeOptions?: Maybe<Array<Maybe<ExchangeOption>>>;
  eContractingFleetInvoiceOptions: FleetInvoiceOptions;
  educationEngineeringApplications?: Maybe<Array<EducationTeaser>>;
  educationQuestions?: Maybe<QuestionsPaginationResult>;
  educationQuickLinks?: Maybe<Array<Link>>;
  eVoucher?: Maybe<EVoucher>;
  eVoucherAccountRestrictedAccountsConfiguration?: Maybe<EVoucherRestrictedAccountsConfigurationPaginationResult>;
  /** @deprecated Use eVoucherAccountRestrictedAccountsConfiguration/eVoucherCampaignRestrictedAccountsConfiguration  */
  eVoucherAccountsAdministrationConfiguration?: Maybe<EVoucherAccountsAdministrationConfiguration>;
  eVoucherCampaignReportState?: Maybe<EVoucherCampaignReportState>;
  eVoucherCampaignRestrictedAccountsConfiguration?: Maybe<EVoucherRestrictedAccountsConfigurationPaginationResult>;
  eVoucherExtendedAdministrationConfiguration?: Maybe<EVoucherAdministrationConfiguration>;
  eVoucherExtendedProductsAdministrationConfiguration?: Maybe<EVoucherProductsAdministrationConfiguration>;
  eVoucherListReportState?: Maybe<EVoucherListReportState>;
  /** @deprecated Use eVoucherExtendedProductsAdministrationConfiguration */
  eVoucherProductsAdministrationConfiguration?: Maybe<EVoucherProductsAdministrationConfiguration>;
  eVouchers?: Maybe<EVoucherPaginationResult>;
  eVoucherStoreConfiguration?: Maybe<EVoucherStoreConfiguration>;
  exchangeableBatteries?: Maybe<ToolsPaginationResult>;
  fleetEContract?: Maybe<EContract>;
  fleetEContractTemplate?: Maybe<EContractTemplate>;
  fleetLabelingTemplates: Array<Maybe<FleetLabelingTemplate>>;
  fleetMasterContractOptions?: Maybe<FleetMasterContractOptions>;
  fleetOrganizationalReferencesAndCostCenters?: Maybe<FleetOrganizationalReferencesAndCostCenters>;
  fleetQuotation?: Maybe<FleetQuotation>;
  fleetQuotations?: Maybe<FleetQuotationPaginationResult>;
  formConfiguration?: Maybe<FormConfiguration>;
  /** Omit journeyId to get default gridPageProductBanner */
  gridPageProductBanner?: Maybe<Banner>;
  hiltiCenter?: Maybe<HiltiCenter>;
  loanToolTrackingDetails?: Maybe<ToolTrackingDetails>;
  localizedDeliveryStatuses?: Maybe<Array<DeliveryStatus>>;
  localizedOrderStatuses?: Maybe<Array<OrderStatus>>;
  localizedOrderTypes?: Maybe<Array<OrderType>>;
  localizedSalesChannels?: Maybe<Array<SalesChannel>>;
  loggedInContext?: Maybe<UserContext>;
  marketingBanner?: Maybe<Banner>;
  /** Omit journeyId to get default megaMenuProductBanner */
  megaMenuProductBanner?: Maybe<Banner>;
  miniCart?: Maybe<Cart>;
  /** Omit categoryId to get the mega menu mini teaser banners */
  miniTeaserBanners?: Maybe<Array<MiniTeaserBanner>>;
  nextWebinar?: Maybe<Webinar>;
  /** @deprecated Use orderDetails */
  order?: Maybe<Order>;
  orderDetails?: Maybe<OrderDetails>;
  orderDraft?: Maybe<OrderDraft>;
  orderDraftDeliveryMethodsShippingDetails?: Maybe<Array<DeliveryMethodShippingDetails>>;
  orderDraftDeliveryTypes?: Maybe<Array<DeliveryType>>;
  orderDraftPaymentMethods?: Maybe<Array<PaymentMethod>>;
  orders?: Maybe<OrderPaginationResult>;
  peakPrice?: Maybe<PeakPrice>;
  peakToolOption?: Maybe<PeakToolOption>;
  product?: Maybe<Product>;
  productByEan?: Maybe<Product>;
  productConfiguration?: Maybe<ProductConfiguration>;
  productsByIds: Array<Product>;
  purchaseRequest?: Maybe<PurchaseRequest>;
  purchaseRequests: PurchaseRequestPaginationResult;
  repairNotificationFilters?: Maybe<RepairNotificationFilters>;
  repairNotifications?: Maybe<RepairNotificationsPaginationResult>;
  repairTrackingDetails?: Maybe<RepairTrackingDetails>;
  repairTrackingNotificationStatuses?: Maybe<RepairNotification>;
  returnToolsDetails?: Maybe<ReturnToolsDetails>;
  searchAddressSuggestions?: Maybe<Array<AddressSuggestion>>;
  searchAutoSuggestions: SearchAutoSuggestions;
  searchEditorials?: Maybe<SearchEditorialsPaginationResult>;
  searchFleetEContractTemplate?: Maybe<EContractTemplate>;
  shippingAddressByOriginId?: Maybe<Account>;
  shippingAddresses?: Maybe<AccountConnection>;
  shippingStores?: Maybe<StoreSearchResults>;
  shoppingList?: Maybe<ShoppingList>;
  shoppingLists?: Maybe<ShoppingListPaginationResult>;
  softwareSubscription?: Maybe<SoftwareSubscription>;
  softwareSubscriptionAvailableProducts?: Maybe<Array<Maybe<Product>>>;
  softwareSubscriptionMasterAgreementAmendmentAllowed?: Maybe<SoftwareSubscriptionMasterAgreementAmendmentAllowedPayload>;
  softwareSubscriptionProductChangeOptions?: Maybe<Array<SoftwareSubscriptionProductChangeOption>>;
  softwareSubscriptions?: Maybe<SoftwareSubscriptionPaginationResult>;
  standardQuotation?: Maybe<StandardQuotation>;
  standardQuotations?: Maybe<StandardQuotationPaginationResult>;
  stockAvailability?: Maybe<StockLevels>;
  storeConfiguration?: Maybe<StoreConfiguration>;
  streetPrices?: Maybe<Array<Price>>;
  toolDocuments: Array<ToolDocument>;
  toolFilters?: Maybe<ToolFilters>;
  tools?: Maybe<ToolsPaginationResult>;
  toolsByIds: Array<Tool>;
  toolsCount?: Maybe<Scalars['Int']>;
  topLevelProductNavigation: Array<Category>;
}

export interface QueryAddressSuggestionArgs {
  filter?: InputMaybe<AddressSuggestionFilterInput>;
  id: Scalars['ID'];
}

export interface QueryAvailabilityStoresArgs {
  filter: StoreSearchFilterInput;
  localization: StoreSearchLocalizationInput;
  location: StoreSearchLocationInput;
}

export interface QueryBatterySelfRecyclingDocumentArgs {
  localization: LocalizationInput;
  productId: Scalars['ID'];
}

export interface QueryBillingAddressesArgs {
  pagination: PageInput;
}

export interface QueryCategoriesByIdsArgs {
  ids: Array<Scalars['ID']>;
  localization: LocalizationInput;
}

export interface QueryCategoryArgs {
  id: Scalars['ID'];
  localization: LocalizationInput;
}

export interface QueryCheckFleetQuotationForAccountEVoucherArgs {
  quotationId: Scalars['String'];
}

export interface QueryCheckStandardQuotationForAccountEVoucherArgs {
  quotationId: Scalars['String'];
}

export interface QueryCircularityReportsArgs {
  pagination?: InputMaybe<PaginationInput>;
}

export interface QueryContactByOriginIdArgs {
  id: Scalars['ID'];
}

export interface QueryContactsArgs {
  pagination: PageInput;
}

export interface QueryContactsAssignableToSubscriptionArgs {
  input?: InputMaybe<ContactsAssignableToSubscriptionInput>;
}

export interface QueryCurrencyExchangeRateArgs {
  currencyFrom: Scalars['String'];
  currencyTo: Scalars['String'];
}

export interface QueryCustomerCareNoteArgs {
  id: Scalars['ID'];
}

export interface QueryCustomerCareNotesArgs {
  orderBy: CustomerCareNoteOrderByInput;
  pagination: PaginationInput;
}

export interface QueryCustomerPricesArgs {
  filter: CustomerPricesFilterInput;
}

export interface QueryEducationEngineeringApplicationsArgs {
  localization: LocalizationInput;
}

export interface QueryEducationQuestionsArgs {
  localization: LocalizationInput;
  pagination: PaginationInput;
}

export interface QueryEducationQuickLinksArgs {
  localization: LocalizationInput;
}

export interface QueryEVoucherArgs {
  id: Scalars['ID'];
}

export interface QueryEVoucherAccountRestrictedAccountsConfigurationArgs {
  filter?: InputMaybe<EVoucherRestrictedAccountsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryEVoucherCampaignReportStateArgs {
  id: Scalars['ID'];
}

export interface QueryEVoucherCampaignRestrictedAccountsConfigurationArgs {
  filter?: InputMaybe<EVoucherRestrictedAccountsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryEVoucherListReportStateArgs {
  filter: EVoucherListReportStateFilterInput;
}

export interface QueryEVouchersArgs {
  filter?: InputMaybe<EVoucherFilterInput>;
  pagination: PaginationInput;
}

export interface QueryExchangeableBatteriesArgs {
  filter?: InputMaybe<ExchangeableBatteriesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}

export interface QueryFleetEContractArgs {
  filter?: InputMaybe<FleetEContractTemplateFilterInput>;
  id: Scalars['ID'];
}

export interface QueryFleetEContractTemplateArgs {
  id: Scalars['ID'];
}

export interface QueryFleetLabelingTemplatesArgs {
  localization: LocalizationInput;
}

export interface QueryFleetMasterContractOptionsArgs {
  localization: LocalizationInput;
  masterContractId?: InputMaybe<Scalars['ID']>;
}

export interface QueryFleetOrganizationalReferencesAndCostCentersArgs {
  masterContractId: Scalars['ID'];
}

export interface QueryFleetQuotationArgs {
  id: Scalars['ID'];
}

export interface QueryFleetQuotationsArgs {
  filter?: InputMaybe<QuotationsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryFormConfigurationArgs {
  localization: LocalizationInput;
  type: FormType;
}

export interface QueryGridPageProductBannerArgs {
  filter?: InputMaybe<ProductBannerFilterInput>;
  localization: LocalizationInput;
}

export interface QueryHiltiCenterArgs {
  id: Scalars['ID'];
}

export interface QueryLoanToolTrackingDetailsArgs {
  loanOrderId: Scalars['ID'];
  localization: LocalizationInput;
}

export interface QueryLocalizedDeliveryStatusesArgs {
  filter?: InputMaybe<LocalizedValueFilterInput>;
  localization: LocalizationInput;
}

export interface QueryLocalizedOrderStatusesArgs {
  filter?: InputMaybe<LocalizedValueFilterInput>;
  localization: LocalizationInput;
}

export interface QueryLocalizedOrderTypesArgs {
  filter?: InputMaybe<LocalizedValueFilterInput>;
  localization: LocalizationInput;
}

export interface QueryLocalizedSalesChannelsArgs {
  filter?: InputMaybe<LocalizedValueFilterInput>;
  localization: LocalizationInput;
}

export interface QueryMarketingBannerArgs {
  filter: MarketingBannerFilterInput;
  localization: LocalizationInput;
}

export interface QueryMegaMenuProductBannerArgs {
  filter?: InputMaybe<ProductBannerFilterInput>;
  localization: LocalizationInput;
}

export interface QueryMiniCartArgs {
  id: Scalars['ID'];
}

export interface QueryMiniTeaserBannersArgs {
  categoryId?: InputMaybe<Scalars['ID']>;
  localization: LocalizationInput;
}

export interface QueryNextWebinarArgs {
  localization: LocalizationInput;
}

export interface QueryOrderArgs {
  id: Scalars['ID'];
  localization?: InputMaybe<LocalizationInput>;
}

export interface QueryOrderDetailsArgs {
  id: Scalars['ID'];
  localization?: InputMaybe<LocalizationInput>;
}

export interface QueryOrderDraftArgs {
  id: Scalars['ID'];
}

export interface QueryOrderDraftDeliveryMethodsShippingDetailsArgs {
  orderDraftId: Scalars['ID'];
}

export interface QueryOrderDraftDeliveryTypesArgs {
  orderDraftId: Scalars['ID'];
}

export interface QueryOrderDraftPaymentMethodsArgs {
  orderDraftId: Scalars['ID'];
}

export interface QueryOrdersArgs {
  filter?: InputMaybe<OrdersFilterInput>;
  pagination: PaginationInput;
}

export interface QueryPeakPriceArgs {
  filter: PeakPriceFilterInput;
  productId: Scalars['ID'];
}

export interface QueryPeakToolOptionArgs {
  localization: LocalizationInput;
  productId: Scalars['ID'];
}

export interface QueryProductArgs {
  id: Scalars['ID'];
  localization: LocalizationInput;
}

export interface QueryProductByEanArgs {
  ean: Scalars['String'];
  localization: LocalizationInput;
}

export interface QueryProductConfigurationArgs {
  id: Scalars['ID'];
}

export interface QueryProductsByIdsArgs {
  ids: Array<Scalars['ID']>;
  localization: LocalizationInput;
}

export interface QueryPurchaseRequestArgs {
  id: Scalars['ID'];
}

export interface QueryPurchaseRequestsArgs {
  filter?: InputMaybe<PurchaseRequestsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryRepairNotificationFiltersArgs {
  filter?: InputMaybe<RepairNotificationFiltersInput>;
}

export interface QueryRepairNotificationsArgs {
  filter?: InputMaybe<RepairNotificationsFilterInput>;
  orderBy?: InputMaybe<RepairNotificationsOrderByInput>;
  pagination: PaginationInput;
}

export interface QueryRepairTrackingDetailsArgs {
  localization: LocalizationInput;
  repairNotificationId: Scalars['ID'];
}

export interface QueryRepairTrackingNotificationStatusesArgs {
  localization: LocalizationInput;
  repairNotificationKey: Scalars['String'];
}

export interface QueryReturnToolsDetailsArgs {
  filter?: InputMaybe<ReturnToolsDetailsFilterInput>;
}

export interface QuerySearchAddressSuggestionsArgs {
  filter: AddressSuggestionFilterInput;
}

export interface QuerySearchAutoSuggestionsArgs {
  filter: SearchAutoSuggestionsFilterInput;
}

export interface QuerySearchEditorialsArgs {
  filter: SearchEditorialsFilterInput;
  localization: LocalizationInput;
  pagination: PaginationInput;
}

export interface QuerySearchFleetEContractTemplateArgs {
  filter: FleetEContractTemplateFilterInput;
}

export interface QueryShippingAddressByOriginIdArgs {
  id: Scalars['ID'];
}

export interface QueryShippingAddressesArgs {
  pagination: PageInput;
}

export interface QueryShippingStoresArgs {
  filter: StoreSearchFilterInput;
  localization: StoreSearchLocalizationInput;
  location: StoreSearchLocationInput;
}

export interface QueryShoppingListArgs {
  id: Scalars['ID'];
}

export interface QueryShoppingListsArgs {
  filter?: InputMaybe<ShoppingListsFilterInput>;
  orderBy?: InputMaybe<ShoppingListsOrderByInput>;
  pagination: PaginationInput;
}

export interface QuerySoftwareSubscriptionArgs {
  id: Scalars['ID'];
}

export interface QuerySoftwareSubscriptionAvailableProductsArgs {
  localization: LocalizationInput;
}

export interface QuerySoftwareSubscriptionMasterAgreementAmendmentAllowedArgs {
  input?: InputMaybe<SoftwareSubscriptionMasterAgreementAmendmentAllowedInput>;
}

export interface QuerySoftwareSubscriptionProductChangeOptionsArgs {
  input?: InputMaybe<SoftwareSubscriptionProductChangeOptionsInput>;
}

export interface QuerySoftwareSubscriptionsArgs {
  filter?: InputMaybe<SoftwareSubscriptionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}

export interface QueryStandardQuotationArgs {
  id: Scalars['ID'];
  localization?: InputMaybe<LocalizationInput>;
}

export interface QueryStandardQuotationsArgs {
  filter?: InputMaybe<QuotationsFilterInput>;
  pagination: PaginationInput;
}

export interface QueryStockAvailabilityArgs {
  input: StockAvailabilityFilterInput;
  localization?: InputMaybe<LocalizationInput>;
}

export interface QueryStoreConfigurationArgs {
  localization: LocalizationInput;
}

export interface QueryStreetPricesArgs {
  filter: PricesFilterInput;
}

export interface QueryToolDocumentsArgs {
  toolId: Scalars['ID'];
}

export interface QueryToolFiltersArgs {
  filter?: InputMaybe<ToolFiltersInput>;
}

export interface QueryToolsArgs {
  filter?: InputMaybe<ToolsFilterInput>;
  orderBy?: InputMaybe<ToolsOrderByInput>;
  pagination: PaginationInput;
}

export interface QueryToolsByIdsArgs {
  ids: Array<Scalars['ID']>;
}

export interface QueryToolsCountArgs {
  filter?: InputMaybe<ToolsFilterInput>;
}

export interface QueryTopLevelProductNavigationArgs {
  localization: LocalizationInput;
}

export interface Question extends Node, Pageable {
  __typename?: 'Question';
  author?: Maybe<Author>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasAcceptedAnswer?: Maybe<Scalars['Boolean']>;
  hasVerifiedAnswer?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  numberOfAnswers?: Maybe<Scalars['Int']>;
  numberOfLikes?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['String']>;
  /** The part of the URL that identifies the particular question in an easy-to-read form used for SEO */
  slug?: Maybe<Scalars['String']>;
  /** Tag or Keywords for the question */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
}

export interface QuestionsPaginationResult extends PaginationResult {
  __typename?: 'QuestionsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<Question>>;
}

export interface QuickAddToCartInput {
  cartId: Scalars['ID'];
  items: Array<CartItemInput>;
}

export interface QuotationsFilterInput {
  buyerContactId?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['Date']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  shipToAccountId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['Date']>;
}

export enum QuotationStatus {
  COMPLETED = 'COMPLETED',
  CONVERTED = 'CONVERTED',
  EXPIRED = 'EXPIRED',
  IN_PROCESS = 'IN_PROCESS',
  OPEN = 'OPEN',
  PARTIALLY_CONVERTED = 'PARTIALLY_CONVERTED'
}

export interface ReactivateEVoucherInput {
  id: Scalars['ID'];
  reactivationReason: Scalars['String'];
}

export interface ReactivateEVoucherPayload {
  __typename?: 'ReactivateEVoucherPayload';
  eVoucherId: Scalars['ID'];
}

export interface ReassignSoftwareSubscriptionContactInput {
  email: Scalars['String'];
  subscriptionId: Scalars['ID'];
}

export interface ReassignSoftwareSubscriptionContactPayload {
  __typename?: 'ReassignSoftwareSubscriptionContactPayload';
  user?: Maybe<LicenseUserAssignment>;
}

export interface RecycleBatteriesDecisionPayload {
  __typename?: 'RecycleBatteriesDecisionPayload';
  toolIds: Array<Maybe<Scalars['String']>>;
}

export interface RecycleBatteriesInput {
  toolIds: Array<InputMaybe<Scalars['String']>>;
}

export interface RecycleToolsForRepairNotificationsInput {
  repairNotificationIds: Array<Scalars['String']>;
}

export interface Region extends Localizable {
  __typename?: 'Region';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface RegionNameArgs {
  localization: LocalizationInput;
}

export interface RegisterAddressInput {
  additionalGeoCode?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  company2?: InputMaybe<Scalars['String']>;
  company3?: InputMaybe<Scalars['String']>;
  company4?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  district?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
  pobox?: InputMaybe<Scalars['String']>;
  postalcode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  streetname?: InputMaybe<Scalars['String']>;
  streetname2?: InputMaybe<Scalars['String']>;
  streetname3?: InputMaybe<Scalars['String']>;
  streetname4?: InputMaybe<Scalars['String']>;
  streetname5?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
  validated?: InputMaybe<Scalars['Boolean']>;
}

export interface RegisterCompanyAccountInput {
  address: RegisterAddressInput;
  customerTax?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<CustomerType>;
  icmsTaxPayer?: InputMaybe<Scalars['String']>;
  legalRepresentative?: InputMaybe<Scalars['String']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']>;
  professionalDescription?: InputMaybe<Scalars['String']>;
  taxJurisdiction?: InputMaybe<Scalars['String']>;
  taxNumber1?: InputMaybe<Scalars['String']>;
  taxNumber2?: InputMaybe<Scalars['String']>;
  taxNumber3?: InputMaybe<Scalars['String']>;
  taxNumber4?: InputMaybe<Scalars['String']>;
  taxNumber5?: InputMaybe<Scalars['String']>;
  taxOffice?: InputMaybe<Scalars['String']>;
  taxStatus?: InputMaybe<Scalars['String']>;
  trade?: InputMaybe<Scalars['String']>;
  tradeName?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
}

export interface RegisterContactInput {
  academicTitle?: InputMaybe<Scalars['String']>;
  authorizedForHiltiOnline?: InputMaybe<Scalars['Boolean']>;
  department?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  function?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

export interface RegisterCustomerInput {
  companyAccount?: InputMaybe<RegisterCompanyAccountInput>;
  contact?: InputMaybe<RegisterContactInput>;
}

export interface RegisterCustomerPayload {
  __typename?: 'RegisterCustomerPayload';
  customerRegistrationId: Scalars['ID'];
}

export interface RegistrationCompanyAccount {
  __typename?: 'RegistrationCompanyAccount';
  address: Address;
  name?: Maybe<Scalars['String']>;
  numberOfEmployees?: Maybe<Scalars['Int']>;
  taxNumber?: Maybe<Scalars['String']>;
  trade?: Maybe<Scalars['String']>;
}

export interface RegistrationContact {
  __typename?: 'RegistrationContact';
  academicTitle?: Maybe<ContactAcademicTitle>;
  fax?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  function?: Maybe<ContactFunction>;
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<ContactTitle>;
}

export interface RegistrationContactInput {
  academicTitle?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  function?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

export interface RegistrationContactPayload {
  __typename?: 'RegistrationContactPayload';
  registrationUserId: Scalars['ID'];
}

export interface RejectFleetQuotationInput {
  quotationId: Scalars['ID'];
}

export interface RejectPurchaseRequestInput {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

export interface ReleaseOrderDraftEVoucherInput {
  orderDraftId: Scalars['ID'];
}

export interface ReleaseOrderDraftEVoucherPayload {
  __typename?: 'ReleaseOrderDraftEVoucherPayload';
  orderDraft: OrderDraft;
}

export interface RemoveAllAccountsFromCampaignEVoucherPayload {
  __typename?: 'RemoveAllAccountsFromCampaignEVoucherPayload';
  eVoucherId: Scalars['ID'];
}

export interface RemoveAllSoftwareSubscriptionScheduledAmendmentsInput {
  subscriptionId: Scalars['ID'];
}

export interface RemoveAllSoftwareSubscriptionScheduledAmendmentsPayload {
  __typename?: 'RemoveAllSoftwareSubscriptionScheduledAmendmentsPayload';
  eContract?: Maybe<EContract>;
}

export interface RemoveItemsFromShoppingListInput {
  itemIds: Array<Scalars['String']>;
  shoppingListId: Scalars['ID'];
}

export interface RemoveItemsFromShoppingListPayload {
  __typename?: 'RemoveItemsFromShoppingListPayload';
  itemIds?: Maybe<Array<Scalars['String']>>;
}

export interface RepairNotification extends Node, Pageable {
  __typename?: 'RepairNotification';
  creationDate?: Maybe<Scalars['Date']>;
  defects?: Maybe<Array<Maybe<ToolDefectInformation>>>;
  /** This is a technical field, not shown in UI - it was added to resolve tracking details based on deliveryId from repair-orders endpoint */
  deliveryId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  loanOrder?: Maybe<Order>;
  repairCost?: Maybe<Money>;
  repairOrder?: Maybe<Order>;
  status?: Maybe<RepairNotificationStatus>;
  tool?: Maybe<Tool>;
  trackingDetails?: Maybe<ShipmentTrackingDetails>;
  trackingEvents?: Maybe<Array<RepairTrackingEvent>>;
  tradeInQuotationDetails?: Maybe<ToolTradeInQuotationDetails>;
}

export interface RepairNotificationTrackingDetailsArgs {
  localization: LocalizationInput;
}

export interface RepairNotificationFilters {
  __typename?: 'RepairNotificationFilters';
  toolCostCenters?: Maybe<Array<Maybe<Scalars['String']>>>;
  toolInventoryNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  toolOrganizationalReferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  toolTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface RepairNotificationFiltersInput {
  toolCostCenter?: InputMaybe<Scalars['String']>;
  toolInventoryNumber?: InputMaybe<Scalars['String']>;
  toolOrganizationalReference?: InputMaybe<Scalars['String']>;
  toolType?: InputMaybe<Scalars['String']>;
}

export interface RepairNotificationsFilterInput {
  country?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<RepairNotificationStatus>>>;
  toolCostCenter?: InputMaybe<Scalars['String']>;
  toolInventoryNumber?: InputMaybe<Scalars['String']>;
  toolOrganizationalReference?: InputMaybe<Scalars['String']>;
  toolType?: InputMaybe<Scalars['String']>;
}

export interface RepairNotificationsOrderByInput {
  creationDate?: InputMaybe<Sort>;
  id?: InputMaybe<Sort>;
  status?: InputMaybe<Sort>;
  toolCostCenter?: InputMaybe<Sort>;
  toolOrganizationalReference?: InputMaybe<Sort>;
  toolSerialNumber?: InputMaybe<Sort>;
  toolType?: InputMaybe<Sort>;
}

export interface RepairNotificationsPaginationResult extends PaginationResult {
  __typename?: 'RepairNotificationsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<RepairNotification>>;
}

export enum RepairNotificationStatus {
  COMPLETED = 'COMPLETED',
  OPEN = 'OPEN'
}

export enum RepairNotificationTrackingStatus {
  ARRIVED_AT_TSC = 'ARRIVED_AT_TSC',
  BOUGHT_NEW_AND_RECYCLED = 'BOUGHT_NEW_AND_RECYCLED',
  DELAYED_EXCEPTIONAL_VOLUME = 'DELAYED_EXCEPTIONAL_VOLUME',
  DELAYED_WAITING_SPAREPARTS = 'DELAYED_WAITING_SPAREPARTS',
  EXPECT_DELAYS = 'EXPECT_DELAYS',
  FAILED_DELIVERY = 'FAILED_DELIVERY',
  IN_DELIVERY_PHASE = 'IN_DELIVERY_PHASE',
  IN_TRANSIT = 'IN_TRANSIT',
  ORDER_RECEIVED = 'ORDER_RECEIVED',
  PACKAGING_ARRIVED = 'PACKAGING_ARRIVED',
  PACKAGING_DISPATCHED = 'PACKAGING_DISPATCHED',
  PICK_UP = 'PICK_UP',
  PICK_UP_DELAYED = 'PICK_UP_DELAYED',
  PICK_UP_FAILED = 'PICK_UP_FAILED',
  QUOTATION_APPROVED = 'QUOTATION_APPROVED',
  READY_FOR_SHIPMENT = 'READY_FOR_SHIPMENT',
  RECYCLED = 'RECYCLED',
  RETURNED = 'RETURNED',
  SENT_BACK_UNREPAIRED = 'SENT_BACK_UNREPAIRED',
  START_TOOL_SERVICE = 'START_TOOL_SERVICE',
  WAITING_QUOTATION_DECISION = 'WAITING_QUOTATION_DECISION'
}

export interface RepairQuotationDecisionPayload {
  __typename?: 'RepairQuotationDecisionPayload';
  repairNotificationIds: Array<Scalars['String']>;
}

export interface RepairTrackingDetails {
  __typename?: 'RepairTrackingDetails';
  billToAccount?: Maybe<Account>;
  mainRepairNotification: RepairNotification;
  pickUpAccount?: Maybe<Account>;
  pickUpCarrierInstructions?: Maybe<Scalars['String']>;
  pickUpContactName?: Maybe<Scalars['String']>;
  pickUpContactPhone?: Maybe<Scalars['String']>;
  pickUpDate?: Maybe<Scalars['Date']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  quotationApprovalContact?: Maybe<Contact>;
  relatedRepairNotifications?: Maybe<Array<RepairNotification>>;
  shippingCharges?: Maybe<Money>;
  shipToAccount?: Maybe<Account>;
  shipToCarrierInstructions?: Maybe<Scalars['String']>;
  shipToContactName?: Maybe<Scalars['String']>;
  shipToContactPhone?: Maybe<Scalars['String']>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
}

export interface RepairTrackingEvent {
  __typename?: 'RepairTrackingEvent';
  estimatedDateFrom?: Maybe<Scalars['DateTime']>;
  estimatedDateTo?: Maybe<Scalars['DateTime']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  status: RepairNotificationTrackingStatus;
}

export interface ReprintOrderDeliveryNotesInput {
  deliveryIds: Array<Scalars['ID']>;
  email: Scalars['String'];
}

export interface ReprintOrderDeliveryNotesPayload {
  __typename?: 'ReprintOrderDeliveryNotesPayload';
  failedDeliveryIds?: Maybe<Array<Scalars['String']>>;
  manualResendRequiredDeliveryIds?: Maybe<Array<Scalars['String']>>;
  successfulDeliveryIds?: Maybe<Array<Scalars['String']>>;
}

export interface ResendFleetQuotationConfirmationInput {
  email: Scalars['String'];
  quotationId: Scalars['ID'];
}

export interface ResendFleetQuotationConfirmationPayload {
  __typename?: 'ResendFleetQuotationConfirmationPayload';
  quotationId: Scalars['ID'];
}

export interface ResendOrderConfirmationInput {
  email: Scalars['String'];
  orderId: Scalars['ID'];
}

export interface ResendOrderConfirmationPayload {
  __typename?: 'ResendOrderConfirmationPayload';
  orderId: Scalars['ID'];
}

export interface ResendOrderDeliveryNotesInput {
  deliveryIds: Array<Scalars['ID']>;
  email: Scalars['String'];
}

export interface ResendOrderDeliveryNotesPayload {
  __typename?: 'ResendOrderDeliveryNotesPayload';
  failedDeliveryIds?: Maybe<Array<Scalars['String']>>;
  successfulDeliveryIds?: Maybe<Array<Scalars['String']>>;
}

export interface ResendQuotationConfirmationInput {
  email: Scalars['String'];
  quotationId: Scalars['ID'];
}

export interface ResendQuotationConfirmationPayload {
  __typename?: 'ResendQuotationConfirmationPayload';
  quotationId: Scalars['ID'];
}

export interface ReturnToolInformation {
  __typename?: 'ReturnToolInformation';
  isBatteryDriven?: Maybe<Scalars['Boolean']>;
  isDangerous?: Maybe<Scalars['Boolean']>;
  isPackagingRecommended?: Maybe<Scalars['Boolean']>;
  tool?: Maybe<Tool>;
}

export interface ReturnToolInput {
  isInOriginalCase: Scalars['Boolean'];
  isPackagingRequired?: InputMaybe<Scalars['Boolean']>;
  productThumbnail?: InputMaybe<Scalars['String']>;
  productTitle?: InputMaybe<Scalars['String']>;
  toolId: Scalars['String'];
}

export interface ReturnToolsDetails {
  __typename?: 'ReturnToolsDetails';
  earliestPickUpDate?: Maybe<Scalars['DateTime']>;
  toolsInformation?: Maybe<Array<Maybe<ReturnToolInformation>>>;
}

export interface ReturnToolsDetailsFilterInput {
  toolIds: Array<InputMaybe<Scalars['String']>>;
}

export interface ReturnToolsInput {
  numberOfPackages: Scalars['Int'];
  pickUpAccountOriginId: Scalars['String'];
  pickUpCarrierInstructions?: InputMaybe<Scalars['String']>;
  pickUpContactOriginId: Scalars['String'];
  pickUpDate: Scalars['Date'];
  returnMethod?: InputMaybe<ToolReturnMethod>;
  tools: Array<ReturnToolInput>;
}

export interface Role extends Node {
  __typename?: 'Role';
  id: Scalars['ID'];
  permissions?: Maybe<Array<Maybe<Permission>>>;
  type: RoleType;
}

export enum RoleType {
  EVOUCHER_BACKOFFICE_USER = 'EVOUCHER_BACKOFFICE_USER'
}

export interface SalesChannel extends Localizable {
  __typename?: 'SalesChannel';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface SalesChannelNameArgs {
  localization: LocalizationInput;
}

export interface SalesUnit extends Localizable {
  __typename?: 'SalesUnit';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
}

export interface SalesUnitNameArgs {
  localization: LocalizationInput;
}

export interface SaveCustomerJourneyInput {
  journeyId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['String']>;
  uri: Scalars['String'];
}

export interface SaveCustomerJourneyPayload {
  __typename?: 'SaveCustomerJourneyPayload';
  journeyId: Scalars['UUID'];
}

export interface SaveInProgressCustomerRegistrationInput {
  companyAccount?: InputMaybe<InProgressCompanyAccountRegistrationInput>;
  contact?: InputMaybe<InProgressContactRegistrationInput>;
}

export interface SaveInProgressCustomerRegistrationPayload {
  __typename?: 'SaveInProgressCustomerRegistrationPayload';
  registrationUserId: Scalars['ID'];
}

export interface SearchAutoSuggestions {
  __typename?: 'SearchAutoSuggestions';
  categories: Array<CategorySearch>;
  products: Array<ProductSearch>;
}

export interface SearchAutoSuggestionsFilterInput {
  includeSpecialProducts?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  localization: LocalizationInput;
  query: Scalars['String'];
}

export interface SearchEditorial extends Pageable {
  __typename?: 'SearchEditorial';
  id: Scalars['ID'];
  summary?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
}

export interface SearchEditorialsFilterInput {
  query: Scalars['String'];
}

export interface SearchEditorialsPaginationResult extends PaginationResult {
  __typename?: 'SearchEditorialsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<SearchEditorial>;
}

export interface SendMessageToCustomerServiceInput {
  country: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  /** The user response token provided by the reCAPTCHA client-side integration. */
  token?: InputMaybe<Scalars['String']>;
}

export interface SendMessageToCustomerServicePayload {
  __typename?: 'SendMessageToCustomerServicePayload';
  status?: Maybe<CustomerServiceMessageStatus>;
}

export interface ShipmentInformation {
  __typename?: 'ShipmentInformation';
  id: Scalars['ID'];
  isDelivered?: Maybe<Scalars['Boolean']>;
  isShipped?: Maybe<Scalars['Boolean']>;
  shipmentItems: Array<ShipmentItem>;
  trackingDetails?: Maybe<ShipmentTrackingDetails>;
}

export interface ShipmentItem {
  __typename?: 'ShipmentItem';
  deliveredQuantity?: Maybe<Scalars['Float']>;
  itemDescription?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  requestedQuantity?: Maybe<Scalars['Float']>;
}

export interface ShipmentItemProductArgs {
  localization: LocalizationInput;
}

export interface ShipmentScheduleInformation {
  __typename?: 'ShipmentScheduleInformation';
  date?: Maybe<Scalars['Date']>;
  shipmentEntryNumber?: Maybe<Scalars['String']>;
  unit?: Maybe<SalesUnit>;
}

export interface ShipmentTrackingDetails {
  __typename?: 'ShipmentTrackingDetails';
  carrierName?: Maybe<Scalars['String']>;
  hasTrackingUrl?: Maybe<Scalars['Boolean']>;
  trackingNumber?: Maybe<Scalars['String']>;
  trackingURL?: Maybe<Scalars['String']>;
}

export interface ShoppingList extends Node, Pageable {
  __typename?: 'ShoppingList';
  account?: Maybe<Account>;
  contact?: Maybe<Contact>;
  createdBy?: Maybe<Contact>;
  creationDate: Scalars['Date'];
  id: Scalars['ID'];
  items?: Maybe<ShoppingListItemPaginationResult>;
  itemsCount: Scalars['Int'];
  modificationDate: Scalars['Date'];
  modifiedBy?: Maybe<Contact>;
  name: Scalars['String'];
}

export interface ShoppingListItemsArgs {
  pagination: PaginationInput;
}

export interface ShoppingListItem extends Node, Pageable {
  __typename?: 'ShoppingListItem';
  id: Scalars['ID'];
  product?: Maybe<Product>;
  quantity: Scalars['Float'];
}

export interface ShoppingListItemProductArgs {
  localization: LocalizationInput;
}

export interface ShoppingListItemInput {
  productId: Scalars['String'];
  quantity: Scalars['Int'];
}

export interface ShoppingListItemPaginationResult extends PaginationResult {
  __typename?: 'ShoppingListItemPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<ShoppingListItem>>;
}

export interface ShoppingListPaginationResult extends PaginationResult {
  __typename?: 'ShoppingListPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<ShoppingList>>;
}

export interface ShoppingListsFilterInput {
  type: ShoppingListType;
}

export interface ShoppingListsOrderByInput {
  createdBy?: InputMaybe<Sort>;
  creationDate?: InputMaybe<Sort>;
  itemsCount?: InputMaybe<Sort>;
  modificationDate?: InputMaybe<Sort>;
  modifiedBy?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
}

export enum ShoppingListType {
  COMPANY = 'COMPANY',
  PRIVATE = 'PRIVATE'
}

export interface SignFleetQuotationInput {
  quotationId: Scalars['ID'];
}

export interface SoftwareAttributes {
  __typename?: 'SoftwareAttributes';
  licenseCategory?: Maybe<ProductFeatureValue>;
  loginUrl?: Maybe<Scalars['String']>;
  userManagementUrl?: Maybe<Scalars['String']>;
}

export interface SoftwareSubscription extends Node, Pageable {
  __typename?: 'SoftwareSubscription';
  adminContact?: Maybe<Contact>;
  billingCycle?: Maybe<BillingCycle>;
  creditCardDetails?: Maybe<CreditCardDetails>;
  endDate?: Maybe<Scalars['DateTime']>;
  hasPendingAmendment?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  latestModification?: Maybe<SoftwareSubscriptionModification>;
  licenseActivationCode?: Maybe<Scalars['String']>;
  licenseGroupId?: Maybe<Scalars['Int']>;
  licenseQuantity?: Maybe<Scalars['Int']>;
  masterAgreementAmendmentUri?: Maybe<Scalars['String']>;
  masterAgreementLicenseUri?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<SoftwareSubscriptionPermission>>;
  price?: Maybe<Money>;
  product?: Maybe<Product>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  refundPrice?: Maybe<Money>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SoftwareSubscriptionStatus>;
  userCount?: Maybe<Scalars['Int']>;
  users?: Maybe<Array<Maybe<LicenseUserAssignment>>>;
  validUntil?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
}

export interface SoftwareSubscriptionProductArgs {
  localization: LocalizationInput;
}

export interface SoftwareSubscriptionRefundPriceArgs {
  effectiveDate: Scalars['Date'];
}

export enum SoftwareSubscriptionAssignmentStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INVITED = 'INVITED'
}

export interface SoftwareSubscriptionContactAssignmentStatus {
  __typename?: 'SoftwareSubscriptionContactAssignmentStatus';
  assigned: Scalars['Boolean'];
  email: Scalars['String'];
}

export interface SoftwareSubscriptionFilterInput {
  statuses?: InputMaybe<Array<InputMaybe<SoftwareSubscriptionStatus>>>;
}

export interface SoftwareSubscriptionMasterAgreementAmendmentAllowedInput {
  eContractId: Scalars['ID'];
}

export interface SoftwareSubscriptionMasterAgreementAmendmentAllowedPayload {
  __typename?: 'SoftwareSubscriptionMasterAgreementAmendmentAllowedPayload';
  isMasterAgreementAmendmentAllowed: Scalars['Boolean'];
}

export interface SoftwareSubscriptionModification {
  __typename?: 'SoftwareSubscriptionModification';
  effectiveDate?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Array<Maybe<SoftwareSubscriptionModificationItem>>>;
}

export interface SoftwareSubscriptionModificationItem {
  __typename?: 'SoftwareSubscriptionModificationItem';
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['Int']>;
}

export interface SoftwareSubscriptionModificationItemProductArgs {
  localization: LocalizationInput;
}

export interface SoftwareSubscriptionPaginationResult extends PaginationResult {
  __typename?: 'SoftwareSubscriptionPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<SoftwareSubscription>>;
}

export enum SoftwareSubscriptionPermission {
  ACTIVATE_LEGACY = 'ACTIVATE_LEGACY',
  CHANGE_LICENSE = 'CHANGE_LICENSE',
  CHANGE_LICENSE_WITH_QUANTITY = 'CHANGE_LICENSE_WITH_QUANTITY',
  CHANGE_QUANTITY = 'CHANGE_QUANTITY',
  MANAGE_USERS = 'MANAGE_USERS',
  OVERRIDE_PRICE = 'OVERRIDE_PRICE'
}

export interface SoftwareSubscriptionProductChangeOption {
  __typename?: 'SoftwareSubscriptionProductChangeOption';
  billingCycle?: Maybe<BillingCycle>;
  product?: Maybe<Product>;
}

export interface SoftwareSubscriptionProductChangeOptionProductArgs {
  localization: LocalizationInput;
}

export interface SoftwareSubscriptionProductChangeOptionsInput {
  productId: Scalars['ID'];
}

export enum SoftwareSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  ACTIVE_LEGACY = 'ACTIVE_LEGACY',
  CANCELED = 'CANCELED',
  CANCELED_LEGACY = 'CANCELED_LEGACY',
  NOT_STARTED = 'NOT_STARTED',
  OTHER = 'OTHER',
  PENDING = 'PENDING'
}

export enum Sort {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface StandardOrderEntry extends GenericOrderEntry {
  __typename?: 'StandardOrderEntry';
  comboChildren?: Maybe<Array<GenericOrderEntry>>;
  deliveryStatus?: Maybe<DeliveryStatus>;
  discount?: Maybe<Discount>;
  entryNumber: Scalars['Int'];
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  invoiceStatus?: Maybe<InvoiceStatus>;
  ipiTax?: Maybe<Money>;
  isHeaderPolicyDiscountExceeded?: Maybe<Scalars['Boolean']>;
  isItemPolicyDiscountExceeded?: Maybe<Scalars['Boolean']>;
  item?: Maybe<Product>;
  itemDescription?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Money>;
  priceUnit?: Maybe<SalesUnit>;
  quantity?: Maybe<Scalars['Float']>;
  rejectionStatus?: Maybe<OrderEntryRejectionStatus>;
  salesUnit?: Maybe<SalesUnit>;
  shippedQuantity?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Money>;
  unitPrice?: Maybe<Money>;
  usagePeriod?: Maybe<Scalars['Int']>;
}

export interface StandardOrderEntryItemArgs {
  localization: LocalizationInput;
}

export interface StandardPrice {
  __typename?: 'StandardPrice';
  price: Scalars['BigDecimal'];
  quantity: Scalars['Float'];
  unit: SalesUnit;
}

export interface StandardPriceDetails {
  __typename?: 'StandardPriceDetails';
  listPriceInformation?: Maybe<StandardPrice>;
  salesPriceInformation?: Maybe<StandardPrice>;
  unitPriceInformation?: Maybe<StandardPrice>;
}

export interface StandardQuotation extends GenericOrder, Node, Pageable {
  __typename?: 'StandardQuotation';
  billToAccount?: Maybe<Account>;
  buyerContact?: Maybe<Contact>;
  date?: Maybe<Scalars['Date']>;
  deliveryInformation?: Maybe<DeliveryInformation>;
  entries: Array<StandardOrderEntry>;
  expirationDate?: Maybe<Scalars['Date']>;
  fcpTax?: Maybe<Money>;
  icmsTax?: Maybe<Money>;
  id: Scalars['ID'];
  ipiTax?: Maybe<Money>;
  /**
   * Flag for distinguishing fleet and standard quotations for ByD markets.
   * To be replaced with query returning FleetQuotation and StandardQuotation types together after MVP and integration in cloud with contract interface
   */
  isFleet?: Maybe<Scalars['Boolean']>;
  isForContract?: Maybe<Scalars['Boolean']>;
  isHeaderPolicyDiscountExceeded?: Maybe<Scalars['Boolean']>;
  isItemPolicyDiscountExceeded?: Maybe<Scalars['Boolean']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<SalesChannel>;
  shippingCharges?: Maybe<Money>;
  shipToAccount?: Maybe<Account>;
  shipToContact?: Maybe<Contact>;
  shipToHiltiCenter?: Maybe<HiltiCenter>;
  soldTo?: Maybe<Customer>;
  status?: Maybe<QuotationStatus>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
  type?: Maybe<OrderType>;
}

export interface StandardQuotationPaginationResult extends PaginationResult {
  __typename?: 'StandardQuotationPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<StandardQuotation>>;
}

export interface StockAvailabilityFilterInput {
  plants: Array<Scalars['String']>;
  productId: Scalars['String'];
  requestedQuantity: Scalars['Int'];
}

export interface StockLevel {
  __typename?: 'StockLevel';
  plantId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  stockStatus?: Maybe<StockLevelStatus>;
}

export interface StockLevels {
  __typename?: 'StockLevels';
  product?: Maybe<Product>;
  results?: Maybe<Array<StockLevel>>;
}

export interface StockLevelsProductArgs {
  localization: LocalizationInput;
}

export enum StockLevelStatus {
  MATERIAL_NOT_AVAILABLE = 'MATERIAL_NOT_AVAILABLE',
  NOT_SUFFICIENT_AMOUNT_AVAILABLE = 'NOT_SUFFICIENT_AMOUNT_AVAILABLE',
  REQUIRED_AMOUNT_AVAILABLE = 'REQUIRED_AMOUNT_AVAILABLE',
  UNKNOWN_AVAILABILITY = 'UNKNOWN_AVAILABILITY'
}

export interface StoreConfiguration extends Node {
  __typename?: 'StoreConfiguration';
  checkout?: Maybe<CheckoutStoreConfiguration>;
  common?: Maybe<CommonStoreConfiguration>;
  fleet?: Maybe<FleetStoreConfiguration>;
  id: Scalars['ID'];
  toolParkManagement?: Maybe<TpmStoreConfiguration>;
}

export interface StoreSearchFilterInput {
  includePickupDropOff?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
}

export interface StoreSearchLocalizationInput {
  country?: InputMaybe<Scalars['String']>;
  requestedUnit?: InputMaybe<DistanceUnit>;
}

export interface StoreSearchLocationInput {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
}

export interface StoreSearchResult {
  __typename?: 'StoreSearchResult';
  distance?: Maybe<Scalars['Float']>;
  hiltiCenter: HiltiCenter;
  unit?: Maybe<DistanceUnit>;
}

export interface StoreSearchResults {
  __typename?: 'StoreSearchResults';
  stores?: Maybe<Array<StoreSearchResult>>;
}

export interface SubmitGuestOrderBillingAddressInput {
  fullName: Scalars['String'];
  postalCode: Scalars['String'];
  streetName: Scalars['String'];
  town: Scalars['String'];
}

export interface SubmitGuestOrderInput {
  billingAddress: SubmitGuestOrderBillingAddressInput;
  creditCardDetails?: InputMaybe<UpdateRapidPayCreditCardDetailsInput>;
  orderDraftId: Scalars['ID'];
  shippingAddress: SubmitGuestOrderShippingAddressInput;
}

export interface SubmitGuestOrderPayload {
  __typename?: 'SubmitGuestOrderPayload';
  internalOrderId: Scalars['ID'];
}

export interface SubmitGuestOrderShippingAddressInput {
  additionalTaxNumber?: InputMaybe<Scalars['String']>;
  company: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  streetName: Scalars['String'];
  taxNumber?: InputMaybe<Scalars['String']>;
  sdiPec?: InputMaybe<Scalars['String']>;
  town: Scalars['String'];
}

export interface SubmitOrderInput {
  carrierInstructions?: InputMaybe<Scalars['String']>;
  creditCardDetails?: InputMaybe<UpdateRapidPayCreditCardDetailsInput>;
  orderDraftId: Scalars['ID'];
  paymentTransactionId?: InputMaybe<Scalars['String']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  termsAndConditionsAccepted: Scalars['Boolean'];
}

export interface SubmitOrderPayload {
  __typename?: 'SubmitOrderPayload';
  internalOrderId: Scalars['ID'];
}

export interface SubscriptionActivationEContractIframeUrlInput {
  returnUri: Scalars['String'];
  subscriptionId: Scalars['ID'];
}

export interface SubscriptionPrice {
  __typename?: 'SubscriptionPrice';
  monthlyPrice: Scalars['BigDecimal'];
  unit?: Maybe<SalesUnit>;
  yearlyPrice: Scalars['BigDecimal'];
}

export interface SubscriptionPriceDetails {
  __typename?: 'SubscriptionPriceDetails';
  billingType: BillingCycle;
  salesPriceInformation: SubscriptionPrice;
  unitPriceInformation: SubscriptionPrice;
}

export interface SubscriptionProratedCharges {
  __typename?: 'SubscriptionProratedCharges';
  currentProrate?: Maybe<Money>;
  prorate?: Maybe<Money>;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  totalPrice?: Maybe<Money>;
}

export interface TargetedCampaignEVoucherDetails {
  __typename?: 'TargetedCampaignEVoucherDetails';
  accountsFileName?: Maybe<Scalars['String']>;
  numberOfAccounts?: Maybe<Scalars['Int']>;
  numberOfContacts?: Maybe<Scalars['Int']>;
}

export interface TemporarilyBanBannerInput {
  bannerId: Scalars['String'];
  journeyId: Scalars['UUID'];
}

export interface TemporarilyBanBannerPayload {
  __typename?: 'TemporarilyBanBannerPayload';
  journeyId: Scalars['UUID'];
}

export interface TimeRange {
  __typename?: 'TimeRange';
  /** End time as a String with the following format  HH:MM:SS */
  end?: Maybe<Scalars['String']>;
  /** Start time as a String with the following format  HH:MM:SS */
  start?: Maybe<Scalars['String']>;
}

export interface Tool extends Node, Pageable {
  __typename?: 'Tool';
  age?: Maybe<Scalars['Int']>;
  comboChildren?: Maybe<Array<Maybe<Tool>>>;
  comboType?: Maybe<ToolComboType>;
  equipmentNumber?: Maybe<Scalars['String']>;
  exchangeDetails?: Maybe<ToolExchangeDetails>;
  fleetDetails?: Maybe<FleetDetails>;
  generation?: Maybe<Scalars['String']>;
  group?: Maybe<ToolGroup>;
  /** Tool has the following pattern TID-materialNumber-serialNumber */
  id: Scalars['ID'];
  location?: Maybe<GeoLocation>;
  originEquipmentNumber?: Maybe<Scalars['String']>;
  peakDetails?: Maybe<ToolPeakDetails>;
  product?: Maybe<Product>;
  purchaseDetails?: Maybe<ToolPurchaseDetails>;
  repairDetails?: Maybe<ToolRepairDetails>;
  salesOrderDetails?: Maybe<ToolSalesOrderDetails>;
  serialNumber?: Maybe<Scalars['String']>;
  status?: Maybe<ToolStatus>;
  type?: Maybe<Scalars['String']>;
}

export interface ToolProductArgs {
  localization: LocalizationInput;
}

export enum ToolComboType {
  BOM = 'BOM',
  SNT = 'SNT'
}

export interface ToolDefect extends Localizable {
  __typename?: 'ToolDefect';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface ToolDefectNameArgs {
  localization: LocalizationInput;
}

export interface ToolDefectInformation {
  __typename?: 'ToolDefectInformation';
  defect: ToolDefect;
  toolPart?: Maybe<ToolDefect>;
}

export interface ToolDocument {
  __typename?: 'ToolDocument';
  size?: Maybe<Scalars['Int']>;
  type: ToolDocumentType;
  uri?: Maybe<Scalars['String']>;
}

export enum ToolDocumentType {
  DELIVERY_NOTE = 'DELIVERY_NOTE',
  REPAIR_CERTIFICATE = 'REPAIR_CERTIFICATE'
}

export interface ToolExchangeDetails {
  __typename?: 'ToolExchangeDetails';
  exchangeStatus?: Maybe<ToolExchangeStatus>;
  hasFollowUpProposals?: Maybe<Scalars['Boolean']>;
}

export enum ToolExchangeStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  REPLACEMENT_REQUIRED = 'REPLACEMENT_REQUIRED'
}

export interface ToolFilters {
  __typename?: 'ToolFilters';
  costCenters?: Maybe<Array<Maybe<Scalars['String']>>>;
  groups?: Maybe<Array<Maybe<ToolGroup>>>;
  inventoryNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationalReferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  statuses?: Maybe<Array<Maybe<ToolStatus>>>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface ToolFiltersInput {
  costCenter?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<ToolGroup>>>;
  inventoryNumber?: InputMaybe<Scalars['String']>;
  organizationalReference?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<ToolStatus>>>;
  type?: InputMaybe<Scalars['String']>;
}

export enum ToolGroup {
  FLEET = 'FLEET',
  LOAN = 'LOAN',
  PEAK = 'PEAK',
  PURCHASED = 'PURCHASED'
}

export enum ToolListColumn {
  CONTRACT_END_DATE = 'CONTRACT_END_DATE',
  CONTRACT_START_DATE = 'CONTRACT_START_DATE',
  CONTRACT_TYPE = 'CONTRACT_TYPE',
  COST_CENTER = 'COST_CENTER',
  EQUIPMENT_NUMBER = 'EQUIPMENT_NUMBER',
  GENERATION = 'GENERATION',
  GROUP = 'GROUP',
  INVENTORY_NUMBER = 'INVENTORY_NUMBER',
  LAST_REPAIR_DATE = 'LAST_REPAIR_DATE',
  LOAN_TOOL_OPTION = 'LOAN_TOOL_OPTION',
  MATERIAL_NUMBER = 'MATERIAL_NUMBER',
  MONTHLY_FEE = 'MONTHLY_FEE',
  NO_COST_EXPIRY_DATE = 'NO_COST_EXPIRY_DATE',
  NUMBER_OF_REPAIRS = 'NUMBER_OF_REPAIRS',
  ORGANIZATIONAL_REFERENCE = 'ORGANIZATIONAL_REFERENCE',
  PEAK_CONTRACT_END_DATE = 'PEAK_CONTRACT_END_DATE',
  PEAK_CONTRACT_START_DATE = 'PEAK_CONTRACT_START_DATE',
  PURCHASE_DATE = 'PURCHASE_DATE',
  PURCHASE_ORDER_NUMBER = 'PURCHASE_ORDER_NUMBER',
  REPAIR_COST = 'REPAIR_COST',
  REPLACEMENT_TOOL = 'REPLACEMENT_TOOL',
  SALES_ORDER_ID = 'SALES_ORDER_ID',
  SERIAL_NUMBER = 'SERIAL_NUMBER',
  STATUS = 'STATUS',
  THEFT_COVERAGE_OPTION = 'THEFT_COVERAGE_OPTION',
  TOOL_DETAILS = 'TOOL_DETAILS',
  TOOL_IMAGE = 'TOOL_IMAGE',
  TOTAL_USAGE_PERIOD = 'TOTAL_USAGE_PERIOD',
  WARRANTY = 'WARRANTY'
}

export interface ToolPeakDetails {
  __typename?: 'ToolPeakDetails';
  contractEndDate?: Maybe<Scalars['Date']>;
  contractStartDate?: Maybe<Scalars['Date']>;
}

export interface ToolPurchaseDetails {
  __typename?: 'ToolPurchaseDetails';
  underWarranty?: Maybe<Scalars['Boolean']>;
  warrantyEndDate?: Maybe<Scalars['Date']>;
}

export interface ToolRepairDetails {
  __typename?: 'ToolRepairDetails';
  lastRepairDate?: Maybe<Scalars['Date']>;
  numberOfRepairs?: Maybe<Scalars['Int']>;
  repairCost?: Maybe<Money>;
}

export enum ToolRepairField {
  NUMBER_OF_PACKAGES = 'NUMBER_OF_PACKAGES',
  PURCHASE_ORDER_DOCUMENT = 'PURCHASE_ORDER_DOCUMENT',
  PURCHASE_ORDER_NUMBER = 'PURCHASE_ORDER_NUMBER'
}

export enum ToolReturnMethod {
  PICKUP = 'PICKUP',
  SHIPPING_LABEL = 'SHIPPING_LABEL'
}

export interface ToolSalesOrderDetails {
  __typename?: 'ToolSalesOrderDetails';
  date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  purchaseOrderNumber?: Maybe<Scalars['String']>;
}

export interface ToolsFilterInput {
  contractEndDateFrom?: InputMaybe<Scalars['Date']>;
  contractEndDateTo?: InputMaybe<Scalars['Date']>;
  costCenter?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<ToolGroup>>>;
  hasFollowUpProposals?: InputMaybe<Scalars['Boolean']>;
  inventoryNumber?: InputMaybe<Scalars['String']>;
  organizationalReference?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<ToolStatus>>>;
  type?: InputMaybe<Scalars['String']>;
}

export interface ToolsOrderByInput {
  contractEndDate?: InputMaybe<Sort>;
  contractStartDate?: InputMaybe<Sort>;
  costCenter?: InputMaybe<Sort>;
  group?: InputMaybe<Sort>;
  inventoryNumber?: InputMaybe<Sort>;
  lastRepairDate?: InputMaybe<Sort>;
  organizationalReference?: InputMaybe<Sort>;
  peakContractEndDate?: InputMaybe<Sort>;
  peakContractStartDate?: InputMaybe<Sort>;
  salesOrderDate?: InputMaybe<Sort>;
  salesOrderId?: InputMaybe<Sort>;
  serialNumber?: InputMaybe<Sort>;
}

export interface ToolsPaginationResult extends PaginationResult {
  __typename?: 'ToolsPaginationResult';
  paginationDetails: PaginationDetails;
  results: Array<Maybe<Tool>>;
}

export interface ToolsProcessPayload {
  __typename?: 'ToolsProcessPayload';
  status?: Maybe<ToolsProcessStatus>;
}

export enum ToolsProcessStatus {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export enum ToolStatus {
  ACTIVE = 'ACTIVE',
  AWAITING_NEW_PRODUCT = 'AWAITING_NEW_PRODUCT',
  COLLECTED = 'COLLECTED',
  ERROR = 'ERROR',
  FLEET_IN_EXTENSION = 'FLEET_IN_EXTENSION',
  FORMER_FLEET_TOOL = 'FORMER_FLEET_TOOL',
  IN_SPECIAL_EXTENSION = 'IN_SPECIAL_EXTENSION',
  LOST = 'LOST',
  NOT_COLLECTED = 'NOT_COLLECTED',
  PEAK_EXTENSION = 'PEAK_EXTENSION',
  SELF_RECYCLING = 'SELF_RECYCLING',
  STOLEN = 'STOLEN',
  TO_BE_COLLECTED = 'TO_BE_COLLECTED'
}

export interface ToolTrackingDetails {
  __typename?: 'ToolTrackingDetails';
  deliveryId?: Maybe<Scalars['String']>;
  trackingDetails?: Maybe<ShipmentTrackingDetails>;
  trackingEvents?: Maybe<Array<ToolTrackingEvent>>;
}

export interface ToolTrackingDetailsTrackingDetailsArgs {
  localization: LocalizationInput;
}

export interface ToolTrackingEvent {
  __typename?: 'ToolTrackingEvent';
  estimatedDateFrom?: Maybe<Scalars['DateTime']>;
  estimatedDateTo?: Maybe<Scalars['DateTime']>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  status: ToolTrackingStatus;
}

export enum ToolTrackingStatus {
  EXPECT_DELAYS = 'EXPECT_DELAYS',
  FAILED_DELIVERY = 'FAILED_DELIVERY',
  GRACE_PERIOD_STARTED = 'GRACE_PERIOD_STARTED',
  IN_TRANSIT = 'IN_TRANSIT',
  LOAN_TOOL_ARRIVED = 'LOAN_TOOL_ARRIVED',
  ORDER_RECEIVED = 'ORDER_RECEIVED',
  PICK_UP = 'PICK_UP',
  PICK_UP_DELAYED = 'PICK_UP_DELAYED',
  PICK_UP_FAILED = 'PICK_UP_FAILED',
  PICK_UP_PLANNED = 'PICK_UP_PLANNED',
  PTP_TOOL_RETURNED = 'PTP_TOOL_RETURNED',
  RENTAL_BILLING_STARTED = 'RENTAL_BILLING_STARTED',
  RETURNED = 'RETURNED',
  TOOL_DISPATCHED = 'TOOL_DISPATCHED'
}

export interface ToolTradeInQuotationDetails {
  __typename?: 'ToolTradeInQuotationDetails';
  monthlyFee?: Maybe<Money>;
  replacementProduct?: Maybe<Product>;
  standardPrice?: Maybe<Money>;
}

export interface ToolTradeInQuotationDetailsReplacementProductArgs {
  localization: LocalizationInput;
}

export interface TpmStoreConfiguration {
  __typename?: 'TPMStoreConfiguration';
  additionalPackagingDays?: Maybe<Scalars['Int']>;
  circularityReports?: Maybe<Scalars['Boolean']>;
  employeeFleetExchangeExtendToolProcess?: Maybe<Scalars['Boolean']>;
  employeeFleetExchangeRenewToolProcess?: Maybe<Scalars['Boolean']>;
  employeeFleetExchangeReturnToolProcess?: Maybe<Scalars['Boolean']>;
  employeeReturnToolProcess?: Maybe<Scalars['Boolean']>;
  fleetExchangeExtendToolProcess?: Maybe<Scalars['Boolean']>;
  fleetExchangeRenewToolProcess?: Maybe<Scalars['Boolean']>;
  fleetExchangeToolProcess?: Maybe<Scalars['Boolean']>;
  fleetPurchaseReturnDangerousToolProcess?: Maybe<Scalars['Boolean']>;
  loanPeakReturnDangerousToolProcess?: Maybe<Scalars['Boolean']>;
  loanToolProcess?: Maybe<Scalars['Boolean']>;
  lostStolenToolProcess?: Maybe<Scalars['Boolean']>;
  lostToolsOathDeclarationRequired?: Maybe<Scalars['Boolean']>;
  peakToolProcess?: Maybe<Scalars['Boolean']>;
  repairTrackingProcess?: Maybe<Scalars['Boolean']>;
  returnToolProcess?: Maybe<Scalars['Boolean']>;
  showPickUpDate?: Maybe<Scalars['Boolean']>;
  showRepairTrackingDates?: Maybe<Scalars['Boolean']>;
  stolenToolsPoliceReportFileExtensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  stolenToolsPoliceReportRequired?: Maybe<Scalars['Boolean']>;
  toolDocumentsDownload?: Maybe<Scalars['Boolean']>;
  toolListColumns?: Maybe<Array<Maybe<ToolListColumn>>>;
  toolParkManagement?: Maybe<Scalars['Boolean']>;
  toolPickupAndDeliveryOptions?: Maybe<Scalars['Boolean']>;
  /** Collection of fields that are displayed on repair tracking, repair, exchange and return processes */
  toolRepairFields?: Maybe<Array<ToolRepairField>>;
}

export interface TradeInAndRecycleToolsForRepairNotificationsInput {
  repairNotificationIds: Array<Scalars['String']>;
}

export interface TransferSoftwareSubscriptionAdminRightsInput {
  adminContactOriginId: Scalars['String'];
  subscriptionId: Scalars['ID'];
  subscriptionVersion?: InputMaybe<Scalars['Int']>;
}

export interface TransferSoftwareSubscriptionAdminRightsPayload {
  __typename?: 'TransferSoftwareSubscriptionAdminRightsPayload';
  adminContact: Contact;
  subscriptionId: Scalars['ID'];
}

export interface UnassignSoftwareSubscriptionContactInput {
  email: Scalars['String'];
  subscriptionId: Scalars['ID'];
}

export interface UnassignSoftwareSubscriptionContactPayload {
  __typename?: 'UnassignSoftwareSubscriptionContactPayload';
  email?: Maybe<Scalars['String']>;
}

export interface UnitOfMeasure extends Localizable {
  __typename?: 'UnitOfMeasure';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
}

export interface UnitOfMeasureNameArgs {
  localization: LocalizationInput;
}

export interface UpdateCampaignEVoucherInput {
  conditionTiers: Array<UpdateCampaignEVoucherTierInput>;
  eligibleProducts?: InputMaybe<UpdateCampaignEVoucherProductsSelectionInput>;
  eVoucherCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  maxNumberOfRedemptions?: InputMaybe<Scalars['Int']>;
  nonTargetedRedemptionRules?: InputMaybe<NonTargetedRedemptionRulesInput>;
  qualifyingProducts?: InputMaybe<UpdateCampaignEVoucherProductsSelectionInput>;
  validFrom?: InputMaybe<Scalars['Date']>;
  validTo?: InputMaybe<Scalars['Date']>;
}

export interface UpdateCampaignEVoucherPayload {
  __typename?: 'UpdateCampaignEVoucherPayload';
  eVoucher: EVoucher;
}

export interface UpdateCampaignEVoucherProductSelectionInput {
  id: Scalars['String'];
  type: EVoucherProductSelectionType;
}

export interface UpdateCampaignEVoucherProductsSelectionInput {
  excludedProducts?: InputMaybe<Array<UpdateCampaignEVoucherProductSelectionInput>>;
  includedProducts?: InputMaybe<Array<UpdateCampaignEVoucherProductSelectionInput>>;
}

export interface UpdateCampaignEVoucherTierInput {
  cartTotal?: InputMaybe<Scalars['BigDecimal']>;
  discountPercentage?: InputMaybe<Scalars['BigDecimal']>;
  discountValue?: InputMaybe<Scalars['BigDecimal']>;
  productsValue?: InputMaybe<Scalars['BigDecimal']>;
}

export interface UpdateContactInput {
  academicTitle?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  function: Scalars['String'];
  id: Scalars['ID'];
  language: Scalars['String'];
  lastName: Scalars['String'];
  mobile?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
}

export interface UpdateContactPayload {
  __typename?: 'UpdateContactPayload';
  contact?: Maybe<Contact>;
}

export interface UpdateEContractInput {
  eContractId: Scalars['ID'];
  eContractView: EContractViewInput;
  templateId: Scalars['String'];
}

export interface UpdateFleetMasterContractInput {
  exchangeCycle?: InputMaybe<ExchangeCycle>;
  exchangeMonth?: InputMaybe<Scalars['Int']>;
  fleetLabelingTemplateId?: InputMaybe<Scalars['String']>;
  invoiceGroupedBy?: InputMaybe<InvoiceOption>;
  invoiceSplitBy?: InputMaybe<InvoiceOption>;
  masterContractId?: InputMaybe<Scalars['String']>;
}

export interface UpdateFleetQuotationEntryInput {
  costCenter?: InputMaybe<Scalars['String']>;
  entryNumber: Scalars['Int'];
  inventoryNumber?: InputMaybe<Scalars['String']>;
  organizationalReference?: InputMaybe<Scalars['String']>;
}

export interface UpdateFleetQuotationInput {
  billToAccountOriginId?: InputMaybe<Scalars['String']>;
  carrierInstructions?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['Date']>;
  entries?: InputMaybe<Array<InputMaybe<UpdateFleetQuotationEntryInput>>>;
  fleetEContractId?: InputMaybe<Scalars['String']>;
  fleetLabelingTemplateId?: InputMaybe<Scalars['String']>;
  fleetMasterContract?: InputMaybe<UpdateFleetMasterContractInput>;
  isSingleShipment?: InputMaybe<Scalars['Boolean']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']>;
  quotationId: Scalars['ID'];
  shipToAccountOriginId?: InputMaybe<Scalars['String']>;
  shipToContactOriginId?: InputMaybe<Scalars['String']>;
}

export interface UpdateFleetQuotationPayload {
  __typename?: 'UpdateFleetQuotationPayload';
  quotationId: Scalars['ID'];
}

export interface UpdateOrderDraftBillToAccountInput {
  billToId: Scalars['String'];
  orderDraftId: Scalars['ID'];
}

export interface UpdateOrderDraftDeliveryMethodInput {
  deliveryMethodId: Scalars['String'];
  orderDraftId: Scalars['ID'];
  requestedDeliveryDate?: InputMaybe<Scalars['Date']>;
}

export interface UpdateOrderDraftEntryPaymentMethodInput {
  entryType: OrderDraftEntryType;
  orderDraftId: Scalars['ID'];
  paymentMethodCode: Scalars['String'];
}

export interface UpdateOrderDraftPayload {
  __typename?: 'UpdateOrderDraftPayload';
  orderDraft: OrderDraft;
}

export interface UpdateOrderDraftPurchaseOrderNumberInput {
  orderDraftId: Scalars['ID'];
  purchaseOrderNumber: Scalars['String'];
}

export interface UpdateOrderDraftShipToAccountInput {
  orderDraftId: Scalars['ID'];
  shipToAccountId: Scalars['String'];
}

export interface UpdateOrderDraftShipToContactInput {
  orderDraftId: Scalars['ID'];
  shipToContactId: Scalars['String'];
}

export interface UpdateOrderDraftShipToHiltiCenterInput {
  hiltiCenterId: Scalars['String'];
  orderDraftId: Scalars['ID'];
}

export interface UpdatePurchaseRequestPayload {
  __typename?: 'UpdatePurchaseRequestPayload';
  id: Scalars['ID'];
}

export interface UpdateRapidPayCreditCardDetailsInput {
  authentication?: InputMaybe<VerifyRapidPayCreditCardAuthenticationInput>;
  authorization: Scalars['JWT'];
}

export interface UpdateShoppingListInput {
  id: Scalars['ID'];
  name: Scalars['String'];
}

export interface UpdateShoppingListPayload {
  __typename?: 'UpdateShoppingListPayload';
  shoppingList?: Maybe<ShoppingList>;
}

export interface UpdateSoftwareSubscriptionPurchaseOrderNumberInput {
  purchaseOrderNumber: Scalars['String'];
  subscriptionId: Scalars['ID'];
  version: Scalars['Int'];
}

export interface UpdateSoftwareSubscriptionPurchaseOrderNumberPayload {
  __typename?: 'UpdateSoftwareSubscriptionPurchaseOrderNumberPayload';
  softwareSubscription?: Maybe<SoftwareSubscription>;
}

export interface UpdateSoftwareSubscriptionRapidPayCreditCardDetailsInput {
  creditCardDetails?: InputMaybe<UpdateRapidPayCreditCardDetailsInput>;
  subscriptionId: Scalars['ID'];
  subscriptionVersion: Scalars['Int'];
}

export interface UpdateSoftwareSubscriptionRapidPayCreditCardDetailsPayload {
  __typename?: 'UpdateSoftwareSubscriptionRapidPayCreditCardDetailsPayload';
  softwareSubscription: SoftwareSubscription;
}

export interface User extends Node, UserContext {
  __typename?: 'User';
  email: Scalars['String'];
  id: Scalars['ID'];
  /** @deprecated Will not be supported in the future. */
  registrationCompanyAccount?: Maybe<RegistrationCompanyAccount>;
  /** @deprecated Will not be supported in the future. */
  registrationContact?: Maybe<RegistrationContact>;
}

/** This interface is designed to be used for Customer, User and Employee. */
export interface UserContext {
  email: Scalars['String'];
  id: Scalars['ID'];
}

export interface ValidatePurchaseOrderNumberInput {
  /** This field is the originId until the full migration of CCMSv2 would be finalized */
  billingAddressId: Scalars['String'];
  orderTypeId: Scalars['String'];
  purchaseOrderNumber: Scalars['String'];
}

export interface ValidatePurchaseOrderNumberPayload {
  __typename?: 'ValidatePurchaseOrderNumberPayload';
  validationStatus: ValidationStatus;
}

export enum ValidationStatus {
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED'
}

export interface VerifyRapidPayCreditCardAuthenticationInput {
  accessToken: Scalars['JWT'];
  authentication: Scalars['String'];
  tokenization: Scalars['JWT'];
}

export interface VerifyRapidPayCreditCardAuthenticationPayload {
  __typename?: 'VerifyRapidPayCreditCardAuthenticationPayload';
  authenticationDetails?: Maybe<Scalars['JSON']>;
}

export interface WebAnalyticsData {
  __typename?: 'WebAnalyticsData';
  trackCreative?: Maybe<Scalars['String']>;
  trackId?: Maybe<Scalars['String']>;
  trackName?: Maybe<Scalars['String']>;
}

export interface Webinar extends Node {
  __typename?: 'Webinar';
  /** Accreditor details for the webinar */
  accreditor?: Maybe<Accreditor>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  sessionDetails?: Maybe<WebinarSessionDetails>;
  /** The part of the URL that identifies the particular webinar in an easy-to-read form used for SEO */
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface WebinarSessionDetails {
  __typename?: 'WebinarSessionDetails';
  count?: Maybe<Scalars['Int']>;
  nextSessionStartsAt?: Maybe<Scalars['DateTime']>;
  nextSessionTimezone?: Maybe<Scalars['TimeZone']>;
}

export interface WeeklyOpeningSchedule {
  __typename?: 'WeeklyOpeningSchedule';
  days?: Maybe<Array<DailyOpeningSchedule>>;
  open?: Maybe<Scalars['Boolean']>;
  timeZone?: Maybe<Scalars['TimeZone']>;
}
